// cp_plocha_v1 (20. 10. 2026): KPI do filtrov, editor po sekciách
// sekcie_v1 (20. 10. 2026, 0.J): DetailRow je jeden, v components/Ui.jsx
// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 6 miest
// ╔══════════════════════════════════════════════════════════════════╗
// ║  _ModuleTemplate.jsx — REFERENČNÁ ŠABLÓNA MODULU MATRIX v2        ║
// ║  Ústava 9.D.1 bod 2 — anti-chyba systém.                          ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  NOVÝ MODUL VZNIKÁ KÓPIOU TOHTO SÚBORU — NIKDY NIE OD NULY.       ║
// ║  Tým sa ústavné systémové veci NEDAJÚ vynechať.                   ║
// ║                                                                  ║
// ║  POSTUP (ústava 9.D.1):                                          ║
// ║   1. PRE-FLIGHT dokument — schváli Mirko PRED prvým riadkom.      ║
// ║   2. cp _ModuleTemplate.jsx → views/MojModul.jsx                 ║
// ║   3. Vyplň CFG · EDIT_FIELDS · STATUS_FILTERS · polia formulára.  ║
// ║   4. Nahraď TODO značky. Skontroluj DoD checklist (dole).         ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  ČO JE V ŠABLÓNE ZABUDOVANÉ (ústavné systémové veci):            ║
// ║   • master-detail layout ......................... sek. 56       ║
// ║   • LOCK multi-user (cez useRecordEditor) ........ sek. 53.7      ║
// ║   • DIRTY dialóg pri odchode ..................... sek. 53.1      ║
// ║   • Form → Confirm + DIFF pred uložením .......... 12.0/3 · 53.8  ║
// ║   • audit kto/čo/kedy (HistoryPanel + auto-log) .. 12.0/1         ║
// ║   • fulltext hľadanie v zozname .................. sek. 56        ║
// ║   • SearchableSelect (žiadny plain <select>) ..... sek. 56.11     ║
// ║   • TINT pozadia (žiadne inline farby) ........... sek. 21.15     ║
// ║   • dedup kontrola (409 z backendu) .............. sek. 13        ║
// ║   • klávesnica (mod+N, /) + cheatsheet ........... sek. 54        ║
// ║   • breadcrumb — rieši Layout .................... sek. 53.2      ║
// ╚══════════════════════════════════════════════════════════════════╝

import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react'
import TelefonInput from '../components/TelefonInput.jsx'
import { normPhone } from '../utils/phone.js'
import useLiveRefresh from '../hooks/useLiveRefresh.js'
import { COLORS, TYPO, SPACE, RADIUS, TINT, SK, todayLocal, norm, hladaj } from '../theme.js'
import NavIcon from '../components/NavIcon.jsx'
import {
  PageHeader, MasterDetail, SearchInput, ListRow, ListStatusBar,
  FilterChips, KpiRow, KpiCard, Tabs, EmptyPane, SearchableSelect,
  NervyPas, DetailRow, Sekcia } from '../components/Ui.jsx'   // cp_plocha_v1
import { Modal } from '../components/Modal.jsx'
// ZDIELANY panel vstupnych udajov + stitok stavu (Mirko 27.7.: „panel o vstupnych udajov
// musia byt v Matrix rovnake" / „rovnaky dizajn = prikaz ustava"). Jedna definicia pre CP,
// predajnovu CP, Objednavky aj Obhliadky — lokalne kopie boli odstranene.
import { Field, FieldGrid, inp } from '../components/DocFields.jsx'
import { KontaktyPonuka, usePartnerKontakty, KontaktnaOsoba, menoZBuniek } from '../components/KontaktyPartnera.jsx'   // V3 131.10
import StatusTag from '../components/StatusTag.jsx'
import SendCustomerDialog from '../components/SendCustomerDialog.jsx'
import ZapisatDoRozpisu from '../components/ZapisatDoRozpisu.jsx'
import KatalogPolozkaModal from '../components/KatalogPolozkaModal.jsx'   // cp_polozka_v1: jeden dialog novej položky (0.J)
import { Btn, BtnAdd, BtnGhost } from '../components/Btn.jsx'
import { HistoryPanel } from '../components/HistoryPanel.jsx'
import HelpHint from '../components/HelpHint.jsx'
import { useToast } from '../components/Toast.jsx'
import { useShortcuts } from '../hooks/useShortcuts.js'
import { useRecordEditor } from '../hooks/useRecordEditor.js'
import { setDirty as setGuardDirty, confirmLeave, pripravDokument, otvorDokument } from '../hooks/unsavedGuard.js'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { usePositionMemory } from '../hooks/usePositionMemory.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'

// cp_osoba_ui_v1 (ÚSTAVA 0.J.M, Mirko 16. 10. 2026: „meno sa nikdy nedopisuje, vždy sa čerpá").
// Predtým tu bol natvrdo vypísaný zoznam troch ľudí (EMP_KM/EMP_KI/EMP_JD) — to je druhý register.
// Po novom rozhoduje ROLA z registra účtov: ponuku vypracúva a obhliadku robí kancelária a vedenie,
// nie parťáci a vodiči. Keď pribudne človek, stačí mu dať rolu — do kódu sa nepíše nič.
const ROLY_CP = ['admin', 'owner', 'owner_view', 'office_manager', 'quotes_specialist', 'foreman', 'accountant', 'service']
const BEZ_OBHLIADKY = 'bez obhliadky'

// PDF cez window.open neprenáša Authorization → token v query (gate ho prijme; Mirko 21.7.)
const pdfUrl = (id, print) => `/api/quotes/${id}/pdf?token=${encodeURIComponent(localStorage.getItem('kamir_token') || '')}` + (print ? '&print=1' : '')
import RowMenu from '../components/RowMenu.jsx'
import useSortable from '../hooks/useSortable.js'
import useOdlozene from '../hooks/useOdlozene.js'   // zoznam_plynuly_v1
import ExportMenu from '../components/ExportMenu.jsx'
import { useConfirm } from '../components/ConfirmDialog.jsx'
import { usePinGate } from '../hooks/usePinGate.jsx'   // cp_zmaz_v1: odoslanú verziu CP odloží až PIN (ústava 63)
import { useNavigate } from 'react-router-dom'
import useOtvorZOdkazu, { odkazNaZaznam, odkazZAdresy, najnovsiaVerzia } from '../hooks/useOtvorZOdkazu.js'   // CP_OTVOR_V1: odkaz ?open= vyhrá nad pamäťou pozície
import NoviCustomerDialog from '../components/NoviCustomerDialog.jsx'   // CP_OTVOR_V1: spoločné okno, adresa v bunkách (23.Z.1)

// ╔═══ KONFIGURÁCIA MODULU — VYPLŇ PRI KOPÍROVANÍ ═══════════════════╗
// DÔLEŽITÉ: resource MUSÍ byť presne cesta API segmentu (napr. 'work-schedule'
// pre /api/work-schedule). Server zapisuje audit pod týmto názvom — ak sa
// nezhoduje, HistoryPanel nenájde históriu (ústava-review 9.D.3).
const CFG = {
  resource:    'quotes',
  apiBase:     '/api/quotes',
  titlePlural: 'Cenové ponuky',
  newLabel:    'Nová CP',
}

// Polia pre DIFF (ústava 53.8) — useRecordEditor ich porovná initial vs. zmenené.
// label = ako sa pole volá v Confirm prehľade. format = voliteľné zobrazenie.
const EDIT_FIELDS = [
  { name: 'quote_number',   label: 'Číslo CP' },
  { name: 'stavba',         label: 'Stavba' },
  { name: 'status',         label: 'Stav' },
  { name: 'notes',          label: 'Poznámka' },
]

// Filter chips (ústava 21.15 — farby gest). key 'all' = bez filtra.
const STATUS_FILTERS = [
  { key: 'all',        label: 'Všetko',      color: COLORS.muted },
  { key: 'draft',      label: 'Pracovné',    color: COLORS.muted },
  { key: 'sent',       label: 'Odoslané',    color: COLORS.nav },
  { key: 'accepted',   label: 'Akceptované', color: COLORS.add },
  { key: 'rejected',   label: 'Zamietnuté',  color: COLORS.remove },
]
const STATUS_LABEL = {
  rozpracovana: 'Pracovná',   // cp_obj_sto_v1: stav, ktorý sem zapisoval server; 6 ponúk v ňom visí bez štítku
  draft:    'Pracovná',
  sent:     'Odoslaná',
  accepted: 'Akceptovaná',
  rejected: 'Zamietnutá',
}

// ══════════════════════════════════════════════════════════════════
// HLAVNÝ KOMPONENT — master-detail stránka (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
export default function ModuleTemplate() {
  const { user } = useAuth()                 // user pre LOCK (53.7)
  const toast = useToast()
  const confirm = useConfirm()
  const pinGate = usePinGate()   // cp_zmaz_v1
  const navigate = useNavigate()

  // ── pamäť pozície (ústava 53.3) — obnoví výber / filter / hľadanie / scroll ──
  const pos = usePositionMemory(CFG.resource)
  const listRef = useRef(null)

  const [rows, setRows]       = useState([])
  const [customers, setCustomersList] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch]   = useState(pos.filter?.search || '')
  const [filter, setFilter]   = useState(pos.filter?.status || 'all')
  // Deep-link /cenove?open=CP-2026-XXX (Mirko 2026-07-15). CP_OTVOR_V1: odkaz má prednosť pred pamäťou pozície
  // už pri prvom vykreslení; otvorenie samotné robí useOtvorZOdkazu nižšie (po načítaní zoznamu).
  const [selectedId, setSelectedId] = useState(() => odkazZAdresy() || pos.selectedRow || null)
  const [modal, setModal]     = useState(null)  // null | {record} | {record:null}
  const [zakCp, setZakCp]     = useState(null)  // (f) CP → zákazka (Mirko 20.7.)

  // ── načítanie dát ────────────────────────────────────────────────
  const load = useCallback(async () => {
    setLoading(true)
    try {
      const r = await fetchAuth(CFG.apiBase)
      const d = await r.json()
      // Predajnove CP (druh='predajna') maju vlastny modul v Predajni — do stavebnych
      // cenovych ponuk NEPATRIA (skreslovali zoznam aj KPI). Audit 28.7.
      const _all = Array.isArray(d) ? d : (d.rows || [])
      setRows(_all.filter(r => String(r.druh || 'stavba') !== 'predajna'))
    } catch (_) {
      toast.error('Dáta sa nenačítali.')
    } finally {
      setLoading(false)
    }
  }, [toast])

  useEffect(() => { load() }, [load])
  useLiveRefresh(load)  // živé obnovenie (SSE, ústava 97)

  // ── Nová CP — Mirko 2026-05-26: žiadny dialog, rovno do plného editora ──
  // Backend POST /api/quotes auto-generuje id + quote_number, prázdne polia OK.
  // Po vytvorení vyberie nový riadok → DetailPane sa otvorí s editorom.
  const handleNewCP = useCallback(async () => {
    try {
      const r = await fetchAuth('/api/quotes', {
        method: 'POST',
        body: JSON.stringify({
          date_issued: todayLocal(),
          created_by: (user && (user.display_name || user.username)) || '',
          // cp_osoby_v1 (Mirko 6. 10. 2026 „kto spracoval CP — podľa používateľa“): Vypracoval sa predvyplní
          // celým menom z karty zamestnanca (auth/me → cele_meno, funkcia_v1). Prepísať sa dá kedykoľvek.
          prepared_by: (user && (user.cele_meno || user.display_name || user.username)) || '',
          prepared_by_id: (user && user.id) || null,   // cp_osoba_ui_v1: rozhoduje účet, meno je len odtlačok
        }),
      })
      const newQ = await r.json()
      if (!r.ok) { toast.error(newQ.error || 'Vytvorenie CP zlyhalo'); return }
      await load()
      navigate(odkazNaZaznam('/cenove', newQ.id), { replace: true })   // CP_OTVOR_V1: otvorí ju aj vtedy, keď filter z pamäte pracovné CP skrýva
      toast.success(`✓ Vytvorená ${newQ.id}`)
    } catch (e) {
      toast.error('Chyba: ' + e.message)
    }
  }, [load, toast, user, navigate])


  // Načítaj customers pre lookup mena v zozname CP
  useEffect(() => {
    fetchAuth('/api/customers').then(r => r.ok ? r.json() : []).then(d => setCustomersList(Array.isArray(d) ? d : [])).catch(() => {})
  }, [])

  // ── Odoslanie CP e-mailom z Matrixu (náhľad pred odoslaním, ústava 67.14 + 531) ──
  const [mailFor, setMailFor] = useState(null)
  const [rozpisFor, setRozpisFor] = useState(null)   // „Zapisat do Rozpisu prac" (Mirko 28.7.)
  const [mailData, setMailData] = useState({ to: '', subject: '', text: '', sending: false })
  // cp_katalog_v1 (Mirko 20. 10. 2026): katalógy referencií k e-mailu CP — človek zaškrtne, či ich priložiť
  const [katDostupne, setKatDostupne] = useState({})
  const [katPriloz, setKatPriloz] = useState([])
  const openSendMail = async (row) => {
    if (!(await pripravDokument(toast))) return   // p95: najprv uložiť, až potom okno odoslania (ústava 67.15)
    let cust = customers.find(c => c.id === row.customerId)
    // údaje zákazníka zo servera (JOIN) sú vždy aktuálne; klientsky zoznam len fallback (Mirko 22.7.)
    let custEmail = row.customer_email || (cust && cust.email) || ''
    let custPhone = row.customer_phone || (cust && (cust.phone || cust.contact)) || ''
    // 🔴 Mirko 11.8.: NOVÝ zákazník (mimo načítaného zoznamu) + detail bez JOIN = prázdny dialóg.
    // Keď e-mail alebo telefón chýba, dotiahni kartu zákazníka priamo zo servera.
    if (row.customerId && (!custEmail || !custPhone)) {
      try { const rc = await fetchAuth('/api/customers/' + row.customerId); if (rc.ok) { const c = await rc.json(); custEmail = custEmail || (c && c.email) || ''; custPhone = custPhone || (c && (c.phone || c.contact)) || '' } } catch (_) {}
    }
    // Kontakt NA DOKLADE ma prednost pred kartou partnera (Mirko 2026-07-27: „ten co je nastaveny
    // u partnera nemusi byt automaticky na ponuky"). Fallback = partner.
    const docEmail = String(row.contact_email || '').trim()
    const docEmail2 = String(row.contact_email2 || '').trim()
    const docPhone = String(row.contact_phone || '').trim()
    const ver = Number(row.doc_version || 1)
    const num = row.quote_number || row.id
    setMailData({
      to: docEmail || custEmail,
      cc: docEmail2,
      // 🔴 OPRAVA 2026-07-27: povodne `custPhone || row.contact` — lenze `quotes.contact` je telefon
      // KAMIRu (backend mu dava default '+421 918 443 675'), takze informativna SMS pre zakaznika
      // odchadzala NA VLASTNE CISLO. Dokaz: sms_log id=16, 27.7. 13:52, '421918443675'.
      phone: normPhone(docPhone || custPhone || ''),
      sms: !!(docPhone || custPhone),
      subject: `Cenová ponuka ${num}` + (ver > 1 ? ' — aktualizácia' : ''),
      text: `Dobrý deň,\n\nv prílohe Vám posielame cenovú ponuku č. ${num}${row.stavba ? ' — ' + row.stavba : ''}${ver > 1 ? ' (aktualizované znenie — nahrádza predchádzajúcu verziu)' : ''}.\n\nV prípade otázok nás neváhajte kontaktovať.\n\nS pozdravom,\nKAMIR s.r.o.`,
      sending: false,
    })
    setKatPriloz([])
    try {
      const rs = await fetchAuth('/api/company-settings')
      const st = rs.ok ? await rs.json() : {}
      const info = (k) => { if (!st['katalog_' + k]) return null; try { return JSON.parse(st['katalog_' + k + '_info'] || '{}') } catch (_) { return {} } }
      setKatDostupne({ omietky: info('omietky'), potery: info('potery') })
    } catch (_) { setKatDostupne({}) }
    setMailFor(row)
  }
  const doSendMail = async () => {
    setMailData(m => ({ ...m, sending: true }))
    try {
      const r = await fetchAuth(`/api/quotes/${mailFor.id}/send-email`, { method: 'POST', body: JSON.stringify({ email: mailData.to, subject: mailData.subject, text: mailData.text }) })
      const d = await r.json(); if (!r.ok) throw new Error(d.error || 'Odoslanie zlyhalo')
      toast.success('Odoslané na ' + d.to + ' — CP je odteraz uzamknutá (úprava cez Aktualizovať).')
      // 103.K (Mirko 6.8.): SMS + zápis do vlákna robí SERVER automaticky pri každom odoslaní — jeden štandard.
      // Frontend SMS neposiela (dvojitá SMS), len zobrazí výsledok.
      if (d.sms && d.sms.ok) toast.success('Informatívna SMS odoslaná na ' + d.sms.to + ' + zapísané do vlákna.')
      else if (d.sms && d.sms.skip) toast.info('SMS sa neposlala: ' + d.sms.skip + '.')
      else if (d.sms && d.sms.fail) toast.error('E-mail OK, ale SMS zlyhala: ' + d.sms.fail)
      setMailFor(null); load()
    } catch (e) { toast.error(e.message); setMailData(m => ({ ...m, sending: false })) }
  }

  // ── filter + fulltext hľadanie (ústava sek. 56) ──────────────────
  const filtered = useMemo(() => {
    const q = norm(search.trim())   // V3: bez diakritiky (66.1)
    return rows.filter(row => {
      if (row.replaced_by) return false  // staré verzie skryť — viditeľná len najnovšia (ústava 67.14)
      // nervy_fe_v1 (ústava 138.3): klik na vetu z nervovej sústavy zúži zoznam presne
      // na to, o čom tá veta hovorí. Rovnaké pravidlo ako v senzore na backende.
      if (filter === 'bez_odpovede') {
        if (!row.sent_at) return false
        if (['accepted', 'rejected', 'akceptovana', 'zamietnuta'].includes(String(row.status || '').toLowerCase())) return false
        if ((Date.now() - Date.parse(row.sent_at)) / 86400000 <= 7) return false
      } else if (filter === 'rozpracovane') {
        if (row.sent_at) return false
        if ((Date.now() - Date.parse(row.updated_at || row.created_at)) / 86400000 <= 14) return false
      } else if (filter === 'mimo_katalogu') {   // cp_polozka_v1: veta nervovej sústavy „položky v ponukách nie sú v katalógu“
        if (!(Number(row.mimo_katalogu) > 0)) return false
      } else if (filter !== 'all' && row.status !== filter) return false
      if (!q) return true
      // hľadá vo všetkých textových poliach záznamu
      return Object.values(row).some(v =>
        v != null && norm(v).includes(q))
    })
  }, [rows, search, filter])

  // zoradenie_v1: podľa čoho sa dá cenové ponuky zoradiť. „Najnovšie" je predvolené poradie zoznamu.
  const ZORADIT = [
    { key: 'created_at', label: 'Najnovšie' },
    { key: 'id', label: 'Číslo' },
    { key: 'customer_name', label: 'Zákazník' },
    { key: 'stavba', label: 'Stavba' },
    { key: 'status', label: 'Stav' },
  ]
  const sortable = useSortable(filtered)
  // V3 P1 (N01): jedno poradie pre zoznam aj šípky — predtým šípky išli podľa `filtered`, zoznam kreslil zoradené pole
  const listRows = useMemo(() => {
    const customerMap = {}
    customers.forEach(c => { customerMap[c.id] = c.name })
    const enriched = filtered.map(r => ({ ...r, _zakaznikMeno: r.customer_name || customerMap[r.customerId] || '— bez zákazníka —' }))
    return sortable.sortKeys.length > 0
      ? sortable.sorted
      : [...enriched].sort((a, b) => String(b.created_at || '').localeCompare(String(a.created_at || '')))
  }, [filtered, customers, sortable.sortKeys, sortable.sorted])

  // CP_OTVOR_V1 (Mirko 22. 10. 2026): /cenove?open=<id alebo číslo CP> otvorí práve tú ponuku — z Obhliadky, Dopytu,
  // Vyúčtovania RD aj po Nová CP / Duplikovať / Aktualizovať. Číslo CP (2026/22-10-164) berie najnovšiu verziu.
  useOtvorZOdkazu({
    rows, loading,
    najdi: (s) => najnovsiaVerzia(rows, rows.find(r => r.id === s) || rows.find(r => r.quote_number === s && !r.replaced_by) || null),   // stará verzia → najnovšia
    viditelny: (row) => filtered.some(r => r.id === row.id),
    vyber: setSelectedId,
    zrusFilter: () => { setFilter('all'); setSearch('') },
  })

  // zoznam_plynuly_v1: detail nedrzi krok s kurzorom — dokresli sa, ked sa kurzor zastavi.
  // Zvyraznenie riadku v zozname ostava okamzite (cita selectedId), odlozeny je len pravy panel.
  const selectedIdDetail = useOdlozene(selectedId, 120)
  const selected = useMemo(
    () => rows.find(r => r.id === selectedIdDetail) || null,
    [rows, selectedIdDetail])

  // ── pamäť pozície — zápis zmien (ústava 53.3) ────────────────────
  useEffect(() => { pos.selectRow(selectedId) }, [selectedId, pos.selectRow])
  useEffect(() => { pos.setFilter({ status: filter, search }) }, [filter, search, pos.setFilter])
  useEffect(() => {
    if (!loading && listRef.current) pos.restoreScroll(listRef.current)
  }, [loading])  // eslint-disable-line react-hooks/exhaustive-deps

  // ── klávesová navigácia zoznamu (ústava 54.2, 56.5) — zdieľaný hook ──
  const openRecord = useCallback((row) => setModal({ record: row }), [])
  useListKeyboard({
    items: listRows,   // V3 P1 (N01)
    selectedId,
    onSelect: (id) => confirmLeave().then(ok => ok && setSelectedId(id)),
    onOpen: openRecord,
    enabled: !modal,
  })

  // ── klávesové skratky (ústava sek. 54) ───────────────────────────
  useShortcuts([
    { keys: 'alt+n', label: CFG.newLabel, scope: CFG.resource,
      handler: handleNewCP },
    { keys: '/', label: 'Hľadať', scope: CFG.resource, handler: () => {
      const el = document.querySelector(`[data-${CFG.resource}-search]`)
      if (el) el.focus()
    } },
  ])

  // ── KPI súhrn (ústava sek. 56.8) ─────────────────────────────────
  const kpi = useMemo(() => ({
    total:  rows.length,
    active: rows.filter(r => r.status === 'active').length,
  }), [rows])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <PageHeader title={CFG.titlePlural} subtitle={`${filtered.length} z ${rows.length}`}>
        <ExportMenu
          data={filtered}
          filename={`cenove-ponuky-${todayLocal()}`}
          title="Cenové ponuky"
          columns={[
            // drobne_v1 (nočný čitateľ): stĺpce „name", „customer_name" a „amount_total" tabuľka quotes
            // vôbec nemá — export mal tri prázdne stĺpce. Zákazník sa v zozname berie z _zakaznikMeno,
            // názov stavby je „stavba". Sumu CP drží súčet riadkov, nie hlavička, takže ju export nemá
            // odkiaľ vziať; radšej žiadny stĺpec než prázdny.
            { key: 'id',             label: 'Číslo CP' },
            { key: 'stavba',         label: 'Stavba' },
            { key: '_zakaznikMeno',  label: 'Zákazník' },
            { key: 'date_issued',    label: 'Dátum vystavenia' },
            { key: 'prepared_by',    label: 'Vypracoval' },
            { key: 'status',         label: 'Stav' },
          ]}
        />
        <BtnAdd onClick={handleNewCP}>+ {CFG.newLabel}</BtnAdd>
      </PageHeader>

      <NervyPas tab="ponuky" vybrane={filter} onVyber={(k) => setFilter(k)} />

      {/* cp_plocha_v1 (Mirko 20. 10.: jeden rad, KPI do filtrov): karty Spolu/Aktívne zrušené — počty sú vo filtroch zoznamu */}

      <MasterDetail
        left={
          <>
            <SearchInput value={search} onChange={setSearch}
              dataAttr={`data-${CFG.resource}-search`}
              placeholder="Hľadať (stlač /)…" />
            {/* zoradenie_v1 (Mirko 13. 10. 2026: „v lavých stlpcoch chýba zoradiť napr. od najnovsích"):
                radenie tu bolo odjakživa (useSortable), ale nebolo ho ako prepnúť — zoznam ticho stál na
                „najnovšie" a človek sa k inému poradiu nedostal. Lišta je tá istá ako v Zamestnancoch,
                aby stĺpce vyzerali a fungovali rovnako. */}
            <div style={{ padding: '4px 10px', borderBottom: `1px solid ${COLORS.line}`,
              display: 'flex', alignItems: 'center', gap: 6, fontSize: TYPO.sizes.xs, color: COLORS.muted, flexWrap: 'wrap' }}>
              <span>Zoradiť:</span>
              {ZORADIT.map(c => {
                const ind = sortable.sortIndicator(c.key)
                return (
                  <button key={c.key} onClick={(e) => sortable.sortClick(c.key)(e)}
                    title="Klik = zoradiť, Shift+klik = pridať druhý kľúč"
                    style={{
                      padding: '2px 8px', background: ind ? COLORS.navBg : 'transparent',
                      border: `1px solid ${ind ? COLORS.brand : COLORS.line}`,
                      borderRadius: RADIUS.full, cursor: 'pointer',
                      fontSize: TYPO.sizes.xs, color: ind ? COLORS.brand : COLORS.muted,
                      fontFamily: 'inherit',
                    }}>{c.label}{ind ? ' ' + ind : ''}</button>
                )
              })}
            </div>
            <FilterChips options={STATUS_FILTERS.map(o => ({ ...o, label: o.label + ' · ' + rows.filter(rw => !rw.replaced_by && (o.key === 'all' || rw.status === o.key)).length }))} value={filter} onChange={setFilter} />   {/* cp_plocha_v1: počty vo filtroch */}
            <div ref={listRef}
              onScroll={e => pos.saveScroll(e.currentTarget.scrollLeft, e.currentTarget.scrollTop)}
              style={{ flex: 1, overflow: 'auto', padding: 6 }}>
              {loading ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  Načítavam…
                </div>
              ) : filtered.length === 0 ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  Žiadne záznamy.
                </div>
              ) : (() => {
                // NOVÉ CP HORE (Mirko 2026-06-01): default sort = created_at DESC (najnovšie prvé).
                // Zoradenie podľa zákazníka/stĺpca ostáva cez klik (sortable). customerMap pre zobrazenie mena.
                const customerMap = {}
                customers.forEach(c => { customerMap[c.id] = c.name })
                // meno zo servera (JOIN /api/quotes) je vždy aktuálne; customerMap len fallback (Mirko 22.7.)
                const enriched = filtered.map(r => ({ ...r, _zakaznikMeno: r.customer_name || customerMap[r.customerId] || '— bez zákazníka —' }))
                const sorted = listRows   // V3 P1 (N01): to isté poradie ako šípky
                return sorted.map(row => (
                <ListRow key={row.id}
                  dataId={row.id}
                  selected={row.id === selectedId}
                  onClick={() => confirmLeave().then(ok => ok && setSelectedId(row.id))}
                  onDoubleClick={() => setModal({ record: row })}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6, alignItems: 'center' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: TYPO.weights.semibold, color: COLORS.text,
                        whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        {row._zakaznikMeno}
                      </div>
                      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono, marginTop: 2 }}>
                        {row.stavba || row.name || '(stavba nevyplnená)'} · {row.id}{row.date_issued ? ' · ' + row.date_issued : ''}
                      </div>
                      {(row.sent_at || row.sms_sent_at || Number(row.doc_version || 1) > 1) && (
                        <div style={{ fontSize: TYPO.sizes.xs, marginTop: 2, whiteSpace: 'nowrap' }}>
                          {Number(row.doc_version || 1) > 1 && <span style={{ color: COLORS.nav, fontWeight: TYPO.weights.semibold, marginRight: 6 }}>v{row.doc_version}</span>}
                          {row.sent_at
                            ? <span style={{ color: COLORS.add, fontWeight: TYPO.weights.semibold }}>E-mail {SK.datumCas(row.sent_at)}</span>
                            : (Number(row.doc_version || 1) > 1
                                ? <span style={{ color: COLORS.warn, fontWeight: TYPO.weights.semibold }}>Aktualizácia — neodoslaná</span>
                                : null)}
                          {row.sms_sent_at && <span style={{ color: COLORS.nav, fontWeight: TYPO.weights.semibold, marginLeft: row.sent_at ? 8 : 0 }}>SMS {SK.datumCas(row.sms_sent_at)}</span>}
                        </div>
                      )}
                    </div>
                    <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
                      <StatusTag status={row.status} />
                      <RowMenu actions={[
                        { key: 'edit',  label: 'Upraviť',      onClick: () => setModal({ record: row }) },
                        { key: 'print', label: 'Tlačiť',       onClick: () => otvorDokument(pdfUrl(row.id, true), toast) },
                        { key: 'pdf',   label: 'Uložiť ako PDF', onClick: () => otvorDokument(pdfUrl(row.id), toast) },
                        { key: 'copy',  label: 'Duplikovať', icon: '⧉', onClick: async () => {
                          const ok = await confirm({
                            title: 'Vytvoriť kópiu cenovej ponuky?',
                            message: `Nová CP s novým číslom a dátumom dnes. Položky z ${row.id} sa skopírujú.`,
                            confirmLabel: 'Vytvoriť kópiu',
                          })
                          if (!ok) return
                          try {
                            const r = await fetchAuth(`/api/cp/${row.id}/copy`, { method: 'POST' })
                            const d = await r.json()
                            if (!r.ok) throw new Error(d.error || 'chyba')
                            toast.success(`Kópia vytvorená: ${d.id}`)
                            await load()
                            // odkazy_v1: server vracia redirect '/cenove/<id>', ale taká trasa neexistuje —
                            // navigate ju zachytilo path="*" a Ely skončila na Môjom dni s pocitom, že sa kópia
                            // nevytvorila. Kópia je v tom istom zozname, tak ju rovno otvoríme (CP_OTVOR_V1: odkazom, aj cez filter).
                            if (d.id) navigate(odkazNaZaznam('/cenove', d.id), { replace: true })
                          } catch (e) { toast.error('Chyba: ' + e.message) }
                        } },
                        ...(row.projectId
                          ? [{ key: 'zak', label: 'Zákazka: ' + row.projectId, onClick: () => navigate('/zakazky/' + encodeURIComponent(row.projectId)) }]   // CP_OTVOR_V1: karta tej zákazky, nie zoznam
                          : [{ key: 'zak', label: 'Vytvoriť zákazku z CP', onClick: () => setZakCp(row) }]),
                        { key: 'spardopyt', label: row.dopyt_id ? ('Dopyt #' + row.dopyt_id + ' (spárovaný)') : 'Spárovať s dopytom…', onClick: async () => {
                          const n = window.prompt('Číslo dopytu (napr. 45):', row.dopyt_id || '')
                          if (!n || !String(n).trim()) return
                          try {
                            const r = await fetchAuth('/api/dopyty/' + String(n).trim() + '/sparuj-cp', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ quote_id: row.id }) })
                            const d = await r.json(); if (!r.ok) throw new Error(d.error || 'HTTP ' + r.status)
                            toast.success('CP spárovaná s dopytom #' + String(n).trim())
                            load()
                          } catch (e) { toast.error('Nepodarilo sa: ' + e.message) }
                        } },
                        // Odoslanie PRIAMO z Matrixu (PDF príloha, ústava 67.14) — mailto zrušené (Apple Mail incident BD Pereš)
                        { key: 'email', label: row.sent_at ? 'Odoslať znova e-mailom' : 'Odoslať e-mailom', onClick: () => openSendMail(row) },
                        { key: 'rozpis', label: 'Zapísať do Rozpisu prác', onClick: () => setRozpisFor(row) },
                        ...(row.sent_at ? [{ key: 'aktualizovat', label: 'Aktualizovať (nová verzia)', icon: '⟳', onClick: async () => {
                          const ok = await confirm({
                            title: 'Aktualizovať cenovú ponuku?',
                            message: `CP ${row.quote_number || row.id} je po odoslaní uzamknutá. Vytvorí sa nová verzia v${Number(row.doc_version || 1) + 1} s rovnakým číslom — tú upravíš a znova odošleš zákazníkovi. Odoslaná verzia ostane archivovaná.`,
                            confirmLabel: 'Vytvoriť novú verziu',
                          })
                          if (!ok) return
                          try {
                            const r = await fetchAuth(`/api/quotes/${row.id}/aktualizovat`, { method: 'POST' })
                            const d = await r.json()
                            if (!r.ok) throw new Error(d.error || 'chyba')
                            toast.success(`Nová verzia v${d.version} vytvorená — uprav a odošli.`)
                            await load()
                            navigate(odkazNaZaznam('/cenove', d.id), { replace: true })   // CP_OTVOR_V1
                          } catch (e) { toast.error('Chyba: ' + e.message) }
                        } }] : []),
                        { key: 'fa',    label: 'Vystaviť FA',    onClick: async () => {
                          const ok = await confirm({
                            title: 'Vystaviť faktúru z cenovej ponuky?',
                            message: `Vystaví sa nová faktúra s údajmi z CP ${row.id} (${row.name || ''}, ${row.customer_name || ''}). CP sa označí ako fakturovaná.`,
                            confirmLabel: 'Vystaviť FA',
                          })
                          if (!ok) return
                          try {
                            const r = await fetchAuth(`/api/cp/${row.id}/issue-fa`, { method: 'POST' })
                            const d = await r.json()
                            if (!r.ok) throw new Error(d.error || 'chyba')
                            toast.success(`Faktúra ${d.fa.cislo} vystavená`)
                            if (d.redirect) navigate(d.redirect)
                          } catch (e) { toast.error('Chyba: ' + e.message) }
                        } },
                        { key: 'obj',   label: 'Vystaviť objednávku', onClick: async () => {
                          const ok = await confirm({
                            title: 'Vystaviť objednávku z cenovej ponuky?',
                            message: `Vytvorí sa nová OBJ s položkami z CP ${row.id} (${row.name || ''}, ${row.customer_name || ''}).`,
                            confirmLabel: 'Vystaviť OBJ',
                          })
                          if (!ok) return
                          try {
                            const r = await fetchAuth(`/api/cp/${row.id}/issue-obj`, { method: 'POST' })
                            const d = await r.json()
                            if (!r.ok) throw new Error(d.error || 'chyba')
                            toast.success(`OBJ ${d.obj.order_number} vystavená`)
                            // CP_OTVOR_V1: server vracia '/objednavky' bez čísla — Objednávky by otvorili naposledy vybranú
                            navigate(d.obj && d.obj.id ? odkazNaZaznam('/objednavky', d.obj.id) : (d.redirect || '/objednavky'))
                          } catch (e) { toast.error('Chyba: ' + e.message) }
                        } },
                        { separator: true },
                        { key: 'del',   label: 'Vymazať',       danger: true, onClick: async () => {
                          const ok = await confirm({
                            title: 'Vymazať cenovú ponuku?',
                            message: `Naozaj zmazať CP ${row.id} (${row.name || '—'})? Zo zoznamu zmizne, z databázy sa nemaže — admin ju vie vrátiť v Logu.`,
                            danger: true, confirmLabel: 'Vymazať',
                          })
                          if (!ok) return
                          try {
                            // cp_zmaz_v1 (8. 10. 2026): keď server povie, že úkon musí schváliť PIN (odoslaná verzia CP),
                            // otvorí sa okno PIN-u a mazanie sa zopakuje so schválením. Rolu zamietne server vetou.
                            let r = await fetchAuth(`/api/quotes/${row.id}`, { method: 'DELETE' })
                            if (!r.ok) {
                              const d = await r.json().catch(() => ({}))
                              if (!d.pin_potrebny) throw new Error(d.error || 'DELETE zlyhal')
                              const gate = await pinGate(d.akcia || 'cp_zmazanie_odoslanej', { cp: row.id, nazov: row.name || '' })
                              if (!gate || !gate.ok) { toast.error('Zrušené — bez PIN-u ponuka ostáva v zozname.'); return }
                              r = await fetchAuth(`/api/quotes/${row.id}`, { method: 'DELETE', headers: { 'X-Pin-Audit-Id': String(gate.audit_id || '') } })
                              if (!r.ok) { const d2 = await r.json().catch(() => ({})); throw new Error(d2.error || 'DELETE zlyhal') }
                            }
                            toast.error('CP vymazaná')
                            load()
                          } catch (e) { toast.error('Chyba: ' + e.message) }
                        } },
                      ]} />
                    </div>
                  </div>
                </ListRow>
              ))})()}
            </div>
            <ListStatusBar>
              ↑↓ výber · Enter detail · Alt+N nový · / hľadať · ⋮ Odoslať e-mailom = PDF z Matrixu, po odoslaní zámok
            </ListStatusBar>
          </>
        }
        right={
          selected
            ? <DetailPane record={selected} onEdit={() => setModal({ record: selected })} onSendMail={openSendMail} />
            : <EmptyPane text="Vyber cenovú ponuku zo zoznamu vľavo" />
        }
      />

      {zakCp && <CpZakazkaModal row={zakCp} toast={toast} customers={customers} onClose={() => setZakCp(null)} onDone={() => { setZakCp(null); load() }} />}
      {modal && (
        <RecordModal
          open
          record={modal.record}
          user={user}
          onClose={() => setModal(null)}
          onSaved={() => {
            setModal(null)
            load()
            toast.success('Uložené.')
          }}
        />
      )}

      {/* Náhľad e-mailu pred odoslaním CP (ústava 531 ConsequencePreview + 67.14) */}
      {rozpisFor && (
        <ZapisatDoRozpisu open onClose={() => setRozpisFor(null)} onSaved={load}
          zdroj={{
            typ: 'cp', id: rozpisFor.id, popis: (rozpisFor.quote_number || rozpisFor.id),
            nazov: rozpisFor.stavba || rozpisFor.name || (rozpisFor.quote_number || rozpisFor.id),
            project_id: rozpisFor.projectId || '',
            customerId: rozpisFor.customerId || '',
            kontakt_meno: rozpisFor.customer_name || '',
            kontakt_telefon: String(rozpisFor.contact_phone || rozpisFor.customer_phone || ''),
            kontakt_email: String(rozpisFor.contact_email || rozpisFor.customer_email || ''),
            kontakt_adresa: rozpisFor.stavba || '',
          }} />
      )}
      {mailFor && (
        <SendCustomerDialog open onClose={() => setMailFor(null)}
          title={`Odoslať CP ${mailFor.quote_number || mailFor.id} zákazníkovi`}
          customerId={mailFor.customerId || ''}
          initTo={mailData.to} initCc={mailData.cc || ''} phone={mailData.phone || ''}
          initSubject={mailData.subject} initText={mailData.text}
          attachmentName={`CP_${String(mailFor.quote_number || mailFor.id).replace(/[^a-zA-Z0-9_-]/g, '_')}.pdf`}
          attachmentNote="vygeneruje sa automaticky z aktuálneho stavu ponuky."
          footNote={'Po odoslaní sa ponuka uzamkne — úprava už len cez „Aktualizovať" (nová verzia, ktorá sa musí znova odoslať). Kópia e-mailu ostane v odoslanej pošte firemnej schránky.'}
          smsLabel="SMS, že mu bola odoslaná CP"
          smsText={'Dobry den, prave sme Vam poslali cenovu ponuku ' + (mailFor.quote_number || mailFor.id) + ' na email. V pripade otazok volajte 0918 443 675. KAMIR'}
          smsEntityType="quote" smsEntityId={mailFor.id}
          extraOption={<KatalogyVolba dostupne={katDostupne} vybrane={katPriloz} onZmena={setKatPriloz} />}
          onSend={async ({ to, cc, subject, text }) => {
            const x = await fetchAuth(`/api/quotes/${mailFor.id}/send-email`, { method: 'POST', body: JSON.stringify({ email: to, cc, subject, text, katalogy: katPriloz }) })
            const d = await x.json(); if (!x.ok) throw new Error(d.error || 'Odoslanie zlyhalo')
            toast.success('CP je odteraz uzamknutá — úprava cez „Aktualizovať".')
            if (Array.isArray(d.katalogy) && d.katalogy.length) toast.success('Priložené katalógy referencií: ' + d.katalogy.map(k => KATALOG_NAZOV[k] || k).join(', ') + '.')
            return { to: d.to, sms: d.sms }   // 103.K — server posiela SMS + vlákno; dialóg len zobrazí výsledok
          }}
          onSent={() => { setMailFor(null); load() }} />
      )}
    </div>
  )
}

// ══════════════════════════════════════════════════════════════════
// STATUS TAG — farebný štítok stavu (ústava 21.15 — z TINT, nie inline)
// ══════════════════════════════════════════════════════════════════
// StatusTag presunuty do ../components/StatusTag.jsx (zdielany, Mirko 27.7.)

// ══════════════════════════════════════════════════════════════════
// DETAIL PANE — pravá strana, taby Detail / História (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
// === CP_FULL_EDITOR_v2 — plný editor CP v Matrixe v2 (žiadny iframe) ===
function DetailPane({ record, onEdit, onSendMail }) {
  const [newCustomerOpen, setNewCustomerOpen] = useState(false)
  const [newCustomerPrefill, setNewCustomerPrefill] = useState('')
  const [tab, setTab] = useState('editor')
  const [quote, setQuote] = useState(record)
  const [lines, setLines] = useState([])
  const saveTimers = useRef({})
  const linesRef = useRef([])
  const [catalog, setCatalog] = useState([])
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [savingTot, setSavingTot] = useState(false)   // prepínač sumáru sa ukladá sám
  const [showPicker, setShowPicker] = useState(false)
  const [novaPolozka, setNovaPolozka] = useState(null)   // cp_polozka_v1: {} = nová, { line, predloha } = zaradiť starú vlastnú položku
  const [showPdfPreview, setShowPdfPreview] = useState(false)
  // cp_osoba_ui_v1: ľudia z REGISTRA ÚČTOV (/api/users už vracia cele_meno z karty zamestnanca aj funkciu)
  const [osoby, setOsoby] = useState([])
  const [ineObhliadka, setIneObhliadka] = useState(false)
  useEffect(() => {
    fetchAuth('/api/users').then(r => (r.ok ? r.json() : [])).then(z => {
      setOsoby((Array.isArray(z) ? z : [])
        .filter(u => ROLY_CP.includes(u.role))
        .map(u => ({ id: u.id, meno: (u.cele_meno || u.display_name || u.username || '').trim(), funkcia: u.funkcia || '' }))
        .filter(u => u.meno)
        .sort((a, b) => a.meno.localeCompare(b.meno, 'sk')))
    }).catch(() => setOsoby([]))
  }, [])
  const toast = useToast()
  // Dočasný kontakt na CP z Nastavení (cp_contact_*) má v PDF PREDNOSŤ pred poľami ponuky, takže
  // obrazovka to musí vedieť — inak by pod poľom tvrdila „vytlačí sa toto číslo" a doklad by
  // vytlačil zastupujúceho človeka (ústava 12.0 bod 4: obrazovka hovorí ČO a PREČO).
  const [zastup, setZastup] = useState(null)
  useEffect(() => {
    fetchAuth('/api/company-settings').then(r => (r.ok ? r.json() : null)).then(n => {
      if (!n) return
      const do_ = String(n.cp_contact_until || '').trim()
      const dnes = todayLocal()
      if (/^\d{4}-\d{2}-\d{2}$/.test(do_) && dnes < do_)
        setZastup({ do_, meno: String(n.cp_contact_name || '').trim(), tel: String(n.cp_contact_phone || '').trim() })
    }).catch(() => {})
  }, [])
  // cp_osoby_v1: celé meno prihláseného z karty zamestnanca (auth/me → cele_meno)
  const { user: prihlaseny } = useAuth()
  const menoPrihlaseneho = (prihlaseny && (prihlaseny.cele_meno || prihlaseny.display_name || prihlaseny.username)) || ''
  // Zámok odoslaného dokumentu (ústava 67.14) — server vynucuje 423, UI len komunikuje
  const docLocked = !!(quote.sent_at && !quote.replaced_by)

  // DIRTY GUARD hlavicky CP (ustava 53.1, Mirko 2026-07-16): polia hlavicky vs posledny ulozeny stav
  const savedHeadRef = useRef(null)
  // POZOR: doc_phone je PRIDANE NA KONIEC. Indexy 14 (vop_override) a 15 (hide_total) sa inde
  // prepisuju rucne v savedHeadRef — vlozenie doprostred by TICHO rozbilo straz neulozenych zmien.
  const headSnap = q => JSON.stringify([q.quote_number, q.customerId, q.projectId, q.stavba, q.date_issued, q.validity_days, q.prepared_by, q.inspected_by, q.prepared_by_id, q.inspected_by_id, q.contact, q.status, q.notes, q.custom_text, q.internal_note, q.vat_rate, q.vop_override, q.hide_total, q.doc_phone])
  const headerDirty = savedHeadRef.current !== null && headSnap(quote) !== savedHeadRef.current
  useEffect(() => {
    const key = 'cp-header:' + record.id
    setGuardDirty(key, headerDirty, () => saveHeader())   // p95: saveHeader vracia true/false
    return () => setGuardDirty(key, false)
  }, [headerDirty, record.id, quote])

  useEffect(() => { setQuote(record); savedHeadRef.current = headSnap(record); reload() }, [record.id])

  async function reload() {
    setLoading(true)
    try {
      const [linesData, catalogData, custData] = await Promise.all([
        fetchAuth(`/api/quotes/${record.id}/lines`).then(r => r.ok ? r.json() : []),
        fetchAuth('/api/quote-catalog').then(r => r.ok ? r.json() : []),   // cp_polozka_v1: aj archivované — riadok ponuky si musí nájsť svoju položku (výpočet kg/m³, príplatky)
        fetchAuth('/api/customers').then(r => r.ok ? r.json() : []),
      ])
      setLines(Array.isArray(linesData) ? linesData : [])
      setCatalog(Array.isArray(catalogData) ? catalogData : [])
      setCustomers(Array.isArray(custData) ? custData : [])
    } catch (e) { toast.error('Chyba načítania: ' + e.message) }
    finally { setLoading(false) }
  }

  function updField(k, v) { setQuote(prev => ({ ...prev, [k]: v })) }

  // Prepínač „Nezobrazovať celkovú sumu" sa ukladá HNEĎ po kliknutí (Mirko 28.8.: predtým čakal
  // na ✓ Uložiť, takže kto rovno otvoril Náhľad PDF, videl sumu ďalej a myslel si, že to nefunguje).
  // Posiela ZÁMERNE iba svoje pole + updated_at — PUT je nedeštruktívny (keep()), takže rozrobené
  // zmeny v hlavičke ostanú neuložené presne tak, ako ich používateľ nechal.
  async function toggleHideTotal(on) {
    if (docLocked || savingTot) return
    const v = on ? 1 : 0
    const prevV = Number(quote.hide_total) === 1 ? 1 : 0
    setSavingTot(true)
    setQuote(prev => ({ ...prev, hide_total: v }))
    try {
      const r = await fetchAuth(`/api/quotes/${quote.id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ hide_total: v, updated_at: quote.updated_at }),
      })
      const d = await r.json().catch(() => null)
      if (!r.ok) throw new Error((d && (d.error || d.message)) || ('HTTP ' + r.status))
      setQuote(prev => ({ ...prev, hide_total: v, updated_at: (d && d.updated_at) || prev.updated_at }))
      // dirty-guard: posuň v uloženom odtlačku iba slot prepínača (index 15) a updated_at,
      // aby appka nepýtala „máš neuložené zmeny" a ostatné rozrobené polia ostali dirty.
      if (savedHeadRef.current) { try { const a = JSON.parse(savedHeadRef.current); a[15] = v; savedHeadRef.current = JSON.stringify(a) } catch (_) {} }
      toast.success(v ? 'Celková suma sa v ponuke nezobrazí.' : 'Celková suma sa v ponuke zobrazuje.')
    } catch (e) {
      setQuote(prev => ({ ...prev, hide_total: prevV }))   // vráť prepínač späť, keď sa neuložilo
      toast.error('Nepodarilo sa uložiť: ' + e.message)
    } finally { setSavingTot(false) }
  }

  async function saveHeader() {
    setSaving(true)
    try {
      const r = await fetchAuth(`/api/quotes/${quote.id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(quote),
      })
      if (!r.ok) throw new Error('save zlyhal')
      const _uq = await r.json().catch(() => null)
      if (_uq && _uq.updated_at) setQuote(prev => ({ ...prev, updated_at: _uq.updated_at }))
      savedHeadRef.current = headSnap(quote)
      toast.success('Hlavička uložená')
      return true
    } catch (e) { toast.error('Chyba: ' + e.message); return false }
    finally { setSaving(false) }
  }

  async function pickItem(item) {
    setShowPicker(false)
    try {
      const r = await fetchAuth(`/api/quotes/${quote.id}/lines`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          catalog_id: item.id,
          title: item.title,
          full_name: item.full_name || '',
          unit: item.unit || 'm²',
          qty: 0,
          price: item.price || 0,
          labor_price: item.labor_price || 0,
          material_price: item.material_price || 0,
          material: item.material || '',
          thickness: item.thickness || '',
          consumption: item.consumption || '',
          description: item.description || '',
          image: item.image || '',
          price_mode: 'combined',
          // Default hrúbka z katalógu pre kg/m3 mode (ústava 21.6.A — Mirko 2026-05-27)
          custom_thickness: (item.material_calc_mode === 'kg' || item.material_calc_mode === 'm3') && item.default_thickness_mm > 0
            ? String(item.default_thickness_mm)
            : '',
        }),
      })
      if (!r.ok) throw new Error('add line zlyhal')
      // AUTO-SKRYTIE priplatkov (Mirko 2026-07-15): polozka katalogu nesie suppress_vop_ids —
      // pri vlozeni do ponuky sa zodpovedajuce priplatky odskrtnu (hole ID vo vop_override = vypnute)
      try {
        let sup = []
        try { sup = JSON.parse(item.suppress_vop_ids || '[]') } catch (_) {}
        if (Array.isArray(sup) && sup.length) {
          let ov = []
          try { ov = JSON.parse(quote.vop_override || '[]') } catch (_) {}
          if (!Array.isArray(ov)) ov = []
          const have = new Set(ov.map(o => (o && typeof o === 'object') ? o.id : o))
          const add = sup.filter(sid => !have.has(sid))
          if (add.length) {
            const r2 = await fetchAuth(`/api/quotes/${quote.id}`, {
              method: 'PUT', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ vop_override: JSON.stringify([...ov, ...add]), updated_at: quote.updated_at }),
            })
            if (r2.ok) {
              const uq = await r2.json()
              setQuote(prev => ({ ...prev, vop_override: uq.vop_override, updated_at: uq.updated_at }))
              if (savedHeadRef.current) { try { const a = JSON.parse(savedHeadRef.current); a[14] = uq.vop_override; savedHeadRef.current = JSON.stringify(a) } catch (_) {} }
              toast.success('Priplatok skryty — zahrnuty v polozke')
            }
          }
        }
      } catch (_) {}
      toast.success(`+ ${item.title}`)
      reload()
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  // cp_polozka_v1: addCustom (položka mimo katalógu) odstránená — nová položka vzniká vždy v katalógu (KatalogPolozkaModal)

  function updateLine(line, changes) {
    // INSTANT lokálny merge → riadkové aj dolné súčty prepočítajú OKAMŽITE (Mirko 2026-06-03 „neprepočítava")
    setLines(prev => prev.map(l => l.id === line.id ? { ...l, ...changes } : l))
    // Debounced PUT (600 ms, per riadok) — pošle AKTUÁLNY plný stav riadka z linesRef (žiadna strata zmien,
    // žiadny reload → kurzor neuteká, ústava KURZOR-FIX 2026-06-01)
    if (saveTimers.current[line.id]) clearTimeout(saveTimers.current[line.id])
    saveTimers.current[line.id] = setTimeout(async () => {
      const cur = (linesRef.current || []).find(l => l.id === line.id) || { ...line, ...changes }
      try {
        const r = await fetchAuth(`/api/quotes/${quote.id}/lines/${line.id}`, {
          method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(cur),
        })
        if (!r.ok) throw new Error('update zlyhal')
      } catch (e) { toast.error('Chyba uloženia riadka: ' + e.message) }
    }, 600)
  }

  async function deleteLine(line) {
    if (!confirm(`Odstrániť riadok "${line.title}"?`)) return
    try {
      await fetchAuth(`/api/quotes/${quote.id}/lines/${line.id}`, { method: 'DELETE' })
      // Mirko 2026-07-15: vratit auto-skryte priplatky, ak ich uz ziadna ina polozka neskryva
      try {
        const cat = catalog.find(c => c.id === line.catalog_id)
        let sup = []
        try { sup = JSON.parse(cat?.suppress_vop_ids || '[]') } catch (_) {}
        if (Array.isArray(sup) && sup.length) {
          const stillSup = new Set()
          for (const l of (linesRef.current || []).filter(x => x.id !== line.id)) {
            const c2 = catalog.find(c => c.id === l.catalog_id)
            try { (JSON.parse(c2?.suppress_vop_ids || '[]') || []).forEach(sid => stillSup.add(sid)) } catch (_) {}
          }
          let ov = []
          try { ov = JSON.parse(quote.vop_override || '[]') } catch (_) {}
          if (!Array.isArray(ov)) ov = []
          const next = ov.filter(o => (o && typeof o === 'object') ? true : !(sup.includes(o) && !stillSup.has(o)))
          if (next.length !== ov.length) {
            const r2 = await fetchAuth(`/api/quotes/${quote.id}`, {
              method: 'PUT', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ vop_override: JSON.stringify(next), updated_at: quote.updated_at }),
            })
            if (r2.ok) { const uq = await r2.json(); setQuote(prev => ({ ...prev, vop_override: uq.vop_override, updated_at: uq.updated_at })); if (savedHeadRef.current) { try { const a = JSON.parse(savedHeadRef.current); a[14] = uq.vop_override; savedHeadRef.current = JSON.stringify(a) } catch (_) {} } }
          }
        }
      } catch (_) {}
      toast.error('Riadok odstránený')
      reload()
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  async function moveLine(line, dir) {
    try {
      const r = await fetchAuth(`/api/quotes/${quote.id}/lines/${line.id}/move`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ dir }),
      })
      if (!r.ok) throw new Error('presun zlyhal')
      reload()
    } catch (e) { toast.error('Chyba: ' + e.message) }
  }

  // CP_TOTAL_FIX 2026-06-01 — efektívna jedn. cena riadka = ROVNAKÝ vzorec ako LineRow,
  // aby dolný súčet (Bez DPH) sedel s riadkami pri split + m³/kg prepočte cez hrúbku (ústava 21.6.A).
  // Dovtedy dolný súčet rátal cez l.price (stará/nepreapočítaná) → nesedelo.
  const _parseThickMm = (t) => {
    if (!t) return 0
    const s = String(t).replace(',', '.').trim()
    const isMeters = /\bm\b|^\d+[.,]\d+$/.test(s) && !s.toLowerCase().includes('mm')
    const n = parseFloat(s.replace(/[^\d.-]/g, ''))
    if (!isFinite(n)) return 0
    return isMeters && n < 10 ? n * 1000 : n
  }
  const _lineUnitPrice = (l) => {
    if ((l.price_mode || 'combined') !== 'split') return Number(l.price) || 0
    const cat = catalog.find(c => c.id === l.catalog_id)
    const munit = l.material_unit || 'm³'
    const mode = cat?.material_calc_mode || (munit === 'm³' || munit === 'm3' ? 'm3' : 'fixed')
    const mm = _parseThickMm(l.custom_thickness || l.thickness || '')
    const mp = Number(l.material_price) > 0 ? Number(l.material_price) : (Number(cat?.material_price) || 0)
    const ck = Number(cat?.consumption_kg_per_m2_per_mm) || 0
    let mat
    if (mode === 'kg' && ck > 0 && mm > 0) mat = ck * mm * (mp / 1000)
    else if (mode === 'm3' && mm > 0) mat = mp * (mm / 1000)
    else mat = mp
    return (Number(l.labor_price) || 0) + mat
  }

  // cp_split_v2 — súčet riadku rovnako ako PDF ponuky (ústava 67.5, cp_split_v1): množstvo 0 = 1;
  // rozdelená cena = realizácia × m² + materiál; pri m³ objem = m² × hrúbka (pri ≤ 1 m² alebo bez hrúbky 1 m³)
  const _lineTotal = (l) => {
    const q = Number(l.qty) > 0 ? Number(l.qty) : 1
    if ((l.price_mode || 'combined') !== 'split') return q * (Number(l.price) || 0)
    const cat = catalog.find(c => c.id === l.catalog_id)
    const munit = l.material_unit || 'm³'
    const mode = cat?.material_calc_mode || (munit === 'm³' || munit === 'm3' ? 'm3' : 'fixed')
    const mm = _parseThickMm(l.custom_thickness || l.thickness || '')
    const mp = Number(l.material_price) > 0 ? Number(l.material_price) : (Number(cat?.material_price) || 0)
    const ck = Number(cat?.consumption_kg_per_m2_per_mm) || 0
    const labor = (Number(l.labor_price) || 0) * q
    if (mode === 'm3') return labor + ((mm > 0 && q > 1) ? q * mm / 1000 : 1) * mp
    if (mode === 'kg' && ck > 0 && mm > 0) return labor + q * ck * mm * (mp / 1000)
    return labor + q * mp
  }

  // Výpočty
  linesRef.current = lines
  const vatRate = Number(quote.vat_rate ?? 20)
  const subTotal = lines.reduce((s, l) => s + _lineTotal(l), 0)
  const vatAmt = subTotal * (vatRate / 100)
  const total = subTotal + vatAmt
  // Variantné položky (Mirko 28.8.) — sumár sa nedostane do PDF, v editore ho office vidí ďalej.
  const hideTot = Number(quote.hide_total) === 1

  return (
    <div style={{
      background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.lg, height: '100%',
      display: 'flex', flexDirection: 'column', overflow: 'hidden',
    }}>
      {/* HLAVIČKA */}
      <div style={{ height: 4, background: COLORS.brand }} />
      <div style={{
        display: 'flex', alignItems: 'center', gap: SPACE.md,
        padding: `${SPACE.sm}px ${SPACE.lg}px`,
        borderBottom: `1px solid ${COLORS.line}`,
        background: COLORS.bg,
      }}>
        <h2 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra,
          color: COLORS.brandText }}>
          {quote.id} · {quote.stavba || '(bez stavby)'}
        </h2>
        <StatusTag status={quote.status} />
        <HelpHint text="ČO: ponuku odošleš zákazníkovi cez ⋮ pri riadku → Odoslať e-mailom (PDF príloha sa vygeneruje automaticky, Komu sa predvyplní z číselníka). PREČO: odoslaná ponuka sa uzamkne — vždy dohľadáš, čo presne zákazník dostal; zmeniť smieš už len stav a interné poznámky. KAM: kópia e-mailu ostane v odoslanej pošte firemnej schránky; úprava = ⋮ Aktualizovať (nová verzia s rovnakým číslom, ktorú znova odošleš). Podrobne: manuál → Odosielanie ponúk a objednávok." />
        {Number(quote.doc_version || 1) > 1 && (
          <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.nav, background: TINT.nav, borderRadius: RADIUS.sm, padding: '1px 7px' }}>verzia {quote.doc_version}</span>
        )}
        <div style={{ flex: 1 }} />
        <Btn variant="ghost" onClick={async () => { if (await pripravDokument(toast)) setShowPdfPreview(true) }}>Náhľad PDF</Btn>
        {onSendMail && <Btn variant="ghost" onClick={() => onSendMail(quote)}>Odoslať e-mailom</Btn>}
        <Btn variant="ghost" onClick={() => otvorDokument(pdfUrl(quote.id, true), toast)}>Tlač</Btn>
        <Btn variant="ghost" onClick={() => otvorDokument(pdfUrl(quote.id), toast)}>PDF</Btn>
        <BtnAdd onClick={saveHeader} disabled={saving || docLocked}>{saving ? 'Ukladám…' : '✓ Uložiť'}</BtnAdd>
      </div>

      {/* Zámok odoslaného dokumentu (ústava 67.14) */}
      {docLocked && (
        <div style={{ padding: `${SPACE.sm}px ${SPACE.lg}px`, background: TINT.add, borderBottom: `1px solid ${COLORS.line}`, fontSize: TYPO.sizes.sm, color: COLORS.text }}>
          <strong style={{ color: COLORS.add }}>Odoslané zákazníkovi {SK.datumCas(quote.sent_at)}</strong>
          {quote.sent_to ? <> na <strong>{quote.sent_to}</strong></> : null} — obsah je uzamknutý presne tak, ako odišiel.
          Na úpravu použi <strong>„Aktualizovať (nová verzia)"</strong> v menu ⋮ pri riadku v zozname.
        </div>
      )}

      {/* Tabs */}
      <Tabs value={tab} onChange={setTab} tabs={[
        { key: 'editor',  label: 'Editor' },
        { key: 'vop',     label: 'VOP' },
        { key: 'history', label: 'História' },
      ]} />

      <div style={{ padding: SPACE.md, overflow: 'auto', flex: 1, background: tab === 'editor' ? COLORS.page : 'transparent' }}>   {/* cp_plocha_v1 (61.10): editor po sekciách na sivom tele */}
        {tab === 'editor' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            {/* Hlavičkové polia · cp_plocha_v1: karta Hlavička ponuky */}
            <Sekcia nazov="Hlavička ponuky" style={{ marginBottom: 0 }}>
            <FieldGrid>
              <Field label="Zákazník">
                <div style={{ display: 'flex', gap: 6 }}>
                  <div style={{ flex: 1 }}>
                    <SearchableSelect value={quote.customerId || ''}
                      allowCreate
                      onChange={v => {
                        // Ústava 2415: ak hodnota nie je existujúce customer ID, otvor mini-dialog s prefilled menom
                        const exists = customers.some(c => c.id === v)
                        if (exists) {
                          updField('customerId', v)
                          // Kontakt z karty partnera doplnime LEN ak je pole na doklade prazdne —
                          // rucne zadany kontakt sa nikdy neprepise (rovnaky princip ako Obhliadky).
                          const cc = customers.find(x => x.id === v)
                          if (cc) {
                            if (!String(quote.contact_email || '').trim() && cc.email) updField('contact_email', cc.email)
                            if (!String(quote.contact_email2 || '').trim() && cc.email2) updField('contact_email2', cc.email2)
                            if (!String(quote.contact_phone || '').trim() && (cc.phone || cc.contact)) updField('contact_phone', cc.phone || cc.contact)
                          }
                        } else if (v && v.trim()) {
                          // Klik na „+ Pridať: <text>" — predvyplň meno
                          setNewCustomerPrefill(v.trim())
                          setNewCustomerOpen(true)
                        }
                      }}
                      options={customers.map(c => ({ value: c.id, label: `${c.name}${c.ico ? ' \u00b7 I\u010cO ' + c.ico : ''} (${c.id})` }))}   /* IČO v labeli — SearchableSelect filtruje podľa labelu, inak placeholder „aj podľa IČO" klame (Mirko 27.7.) */
                      placeholder="Hľadať podľa mena alebo IČO…" />
                  </div>
                  <button type="button" onClick={() => setNewCustomerOpen(true)} title="Vytvoriť nového zákazníka (ústava sek. 13/21.5/53.7)"
                    style={{ padding: '0 12px', border: `1px solid ${COLORS.line}`, background: COLORS.bg, color: COLORS.brand,
                      borderRadius: RADIUS.sm, cursor: 'pointer', fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.sm, fontFamily: 'inherit', whiteSpace: 'nowrap' }}>
                    + Nový
                  </button>
                </div>
                {/* Referencia z karty partnera. Doklad ma VLASTNE polia nizsie (Mirko 27.7.) */}
                {(() => {
                  const sc = customers.find(c => c.id === quote.customerId)
                  const em = sc && sc.email
                  const ph = sc && (sc.phone || sc.contact)
                  if (!em && !ph) return null
                  return (
                    <div style={{ marginTop: 5, fontSize: TYPO.sizes.xs, color: COLORS.muted, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                      <span style={{ opacity: 0.75 }}>Na karte partnera:</span>
                      {em && <span>E-mail: <strong style={{ color: COLORS.text }}>{em}</strong></span>}
                      {ph && <span>Tel: <strong style={{ color: COLORS.text }}>{normPhone(ph)}</strong></span>}
                    </div>
                  )
                })()}
                <KontaktyPartneraCP customerId={quote.customerId} quote={quote} updField={updField} />
              </Field>
              <Field label="Stavba / Projekt">
                <input style={inp} value={quote.stavba || ''}
                  onChange={e => updField('stavba', e.target.value)} placeholder="RD Krompachy" />
              </Field>
              <Field label="Číslo CP">
                <input style={inp} value={quote.quote_number || ''}
                  onChange={e => updField('quote_number', e.target.value)} />
              </Field>
              <Field label="Dátum vystavenia">
                <input style={inp} type="date" value={quote.date_issued || ''}
                  onChange={e => updField('date_issued', e.target.value)} />
              </Field>
              <Field label="Platnosť (dní)">
                <input style={inp} type="number" value={quote.validity_days || 14}
                  onChange={e => updField('validity_days', Number(e.target.value) || 14)} />
              </Field>
              <Field label="Stav">
                <select style={inp} value={quote.status || 'draft'}
                  onChange={e => updField('status', e.target.value)}>
                  {Object.entries(STATUS_LABEL).map(([k, v]) => (
                    <option key={k} value={k}>{v}</option>
                  ))}
                </select>
              </Field>
              {/* cp_osoby_v1: nová ponuka sa zakladá už s menom prihláseného (handleNewCP).
                  Pri starších ponukách doplní meno jedno kliknutie — prepísať sa dá vždy. */}
              {/* Rovnaké slovo ako na PDF („Vypracoval") — kým sa pole menovalo „Pripravil",
                  nebolo vidieť, že práve ono je ten údaj na doklade. */}
              {/* cp_osoba_ui_v1: výber z ľudí namiesto písania. Ukladá sa ÚČET (prepared_by_id),
                  meno na doklad vykreslí server z karty zamestnanca. Staršia ponuka, ktorej meno
                  k účtu nepatrí (externý človek), sa NEZAHADZUJE — ukáže sa ako vlastná položka. */}
              <Field label="Vypracoval (tlačí sa na PDF)">
                {(() => {
                  const vid = quote.prepared_by_id == null ? '' : String(quote.prepared_by_id)
                  const nezname = !vid && String(quote.prepared_by || '').trim()
                  return (
                    <select style={inp} value={nezname ? '__stare__' : vid}
                      onChange={e => {
                        const v = e.target.value
                        if (v === '__stare__') return
                        const o = osoby.find(x => String(x.id) === v)
                        updField('prepared_by_id', v === '' ? null : Number(v))
                        updField('prepared_by', o ? o.meno : '')
                      }}>
                      <option value="">— nevyplnené —</option>
                      {nezname && <option value="__stare__">{quote.prepared_by} (pôvodný zápis)</option>}
                      {osoby.map(o => <option key={o.id} value={String(o.id)}>{o.meno}{o.funkcia ? ' · ' + o.funkcia : ''}</option>)}
                    </select>
                  )
                })()}
              </Field>
              <Field label="DPH %">
                <input style={inp} type="number" value={quote.vat_rate ?? 20}
                  onChange={e => updField('vat_rate', Number(e.target.value) || 0)} />
              </Field>
              {/* TELEFÓN NA DOKLADE — `quotes.doc_phone`, len pre túto ponuku (Mirko 6. 10. 2026).
                  Zámok na vstupe podľa ústavy 112 (TelefonInput). Staré pole `quotes.contact` sa tu
                  už needituje: nie je to náš telefón, ale popis kontaktu zákazníka — číta ho výber
                  CP v obhliadke aj vyúčtovanie (dodacie listy). */}
              <Field label="Telefón na doklade">
                <TelefonInput style={inp} value={quote.doc_phone || ''} disabled={docLocked}
                  placeholder="prázdne = telefón firmy z Nastavení"
                  onChange={val => updField('doc_phone', val)} />
                <div style={{ fontSize: TYPO.sizes.xs, color: zastup ? COLORS.remove : COLORS.muted, marginTop: 2, lineHeight: 1.3 }}>
                  {zastup
                    ? `Do ${zastup.do_.split('-').reverse().join('. ')} sa na PDF tlačí zastupujúci kontakt z Nastavení${zastup.tel ? ' (' + zastup.tel + ')' : ''} — toto pole sa dovtedy neprejaví.`
                    : (String(quote.doc_phone || '').trim()
                        ? 'Na PDF sa vytlačí toto číslo — len na tejto ponuke.'
                        : 'Teraz sa tlačí telefón firmy z Nastavení → Firma.')}
                </div>
              </Field>
              {/* KONTAKT ZAKAZNIKA NA DOKLADE (Mirko 2026-07-27) — nezavisly od karty partnera:
                  „ten co je nastaveny u partnera nemusi byt automaticky na ponuky". Sem sa posiela CP. */}
              {/* ústava 131.10 + 0.J (p93): JEDEN blok kontaktnej osoby v celom Matrixe — osoba z registra partnera.
                  CP nemá stĺpec pre meno — meno a funkciu ukáže register podľa e-mailu. Sem sa posiela CP. */}
              <KontaktnaOsoba customerId={quote.customerId} zamknute={docLocked} ulozMeno={false} inp={inp}
                osoba={{ telefon: quote.contact_phone, email: quote.contact_email }}
                onZmena={o => { updField('contact_email', o.email); updField('contact_phone', o.telefon) }}
                popisy={{ email: 'E-mail zákazníka (sem ide ponuka)', telefon: 'Telefón zákazníka (SMS)' }}
                placeholdery={{ email: 'prázdne = použije sa e-mail z karty partnera', telefon: 'prázdne = telefón z karty partnera' }}
                obal={(tx, pole, kl) => <Field key={kl} label={tx}>{pole}</Field>} />
              <Field label="E-mail zákazníka 2 (kópia)">
                <input style={inp} type="email" value={quote.contact_email2 || ''}
                  placeholder="napr. druhy kontakt na stavbe"
                  onChange={e => updField('contact_email2', e.target.value)} />
                {!docLocked && <KontaktyPonuka customerId={quote.customerId} hodnota={quote.contact_email2} popis="Kópia" sNovym={false}
                  onVyber={(k, uzJe) => { updField('contact_email2', uzJe ? '' : k.email); if (!uzJe && k.telefon && !String(quote.contact_phone || '').trim()) updField('contact_phone', k.telefon) }} />}
              </Field>
              {/* cp_osoby_v1 (Mirko 6. 10. 2026): výber namiesto voľného textu — v 119 ponukách bolo jedno meno
                  zapísané 11 spôsobmi („Kopeček“, „Kopeček Ivan“, „Kopeček Ivan “, „Ivan Kopeček“).
                  Hodnota, ktorá v zozname nie je (staršie ponuky, jednorazový človek), sa NEZAHADZUJE —
                  ponuka ju ukáže ako vlastnú položku; „iné meno…“ otvorí voľný text. */}
              {/* cp_osoba_ui_v1: ukladá sa ÚČET (inspected_by_id). „bez obhliadky" nie je človek,
                  preto je to vlastná položka bez účtu; „iné meno…" ostáva pre jednorazového človeka
                  bez účtu (napr. externý technik) — vtedy je účet prázdny a drží sa len text. */}
              <Field label="Obhliadku vykonal">
                {(() => {
                  const vid = quote.inspected_by_id == null ? '' : String(quote.inspected_by_id)
                  const txt = String(quote.inspected_by || '').trim()
                  const jeBez = !vid && txt === BEZ_OBHLIADKY
                  const nezname = !vid && txt && !jeBez
                  return ineObhliadka ? (
                    <input style={inp} value={txt} autoFocus placeholder="meno človeka, ktorý obhliadku urobil"
                      onChange={e => { updField('inspected_by_id', null); updField('inspected_by', e.target.value) }}
                      onBlur={() => { if (!String(quote.inspected_by || '').trim()) setIneObhliadka(false) }} />
                  ) : (
                    <select style={inp} value={jeBez ? '__bez__' : (nezname ? '__stare__' : vid)}
                      onChange={e => {
                        const v = e.target.value
                        if (v === '__stare__') return
                        if (v === '__ine__') { setIneObhliadka(true); updField('inspected_by_id', null); updField('inspected_by', ''); return }
                        if (v === '__bez__') { updField('inspected_by_id', null); updField('inspected_by', BEZ_OBHLIADKY); return }
                        const o = osoby.find(x => String(x.id) === v)
                        updField('inspected_by_id', v === '' ? null : Number(v))
                        updField('inspected_by', o ? o.meno : '')
                      }}>
                      <option value="">— nevyplnené —</option>
                      {nezname && <option value="__stare__">{txt} (pôvodný zápis)</option>}
                      {osoby.map(o => <option key={o.id} value={String(o.id)}>{o.meno}{o.funkcia ? ' · ' + o.funkcia : ''}</option>)}
                      <option value="__bez__">{BEZ_OBHLIADKY}</option>
                      <option value="__ine__">iné meno…</option>
                    </select>
                  )
                })()}
              </Field>
            </FieldGrid>
            </Sekcia>

            {/* Položky */}
            <div style={{
              background: COLORS.bg, border: `1px solid ${COLORS.line}`,
              borderRadius: RADIUS.lg, overflow: 'hidden',   // cp_plocha_v1: karta
            }}>
              <div style={{
                padding: `${SPACE.sm}px ${SPACE.md}px`,
                background: COLORS.bgSoft, borderBottom: `1px solid ${COLORS.line}`,
                display: 'flex', alignItems: 'center', gap: SPACE.sm,
              }}>
                <span style={{ fontSize: TYPO.sizes.base, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Položky ponuky <span style={{ fontWeight: TYPO.weights.normal, textTransform: 'none', letterSpacing: 0, fontSize: TYPO.sizes.sm }}>{lines.length}</span></span>
                <div style={{ flex: 1 }} />
                <BtnAdd onClick={() => setShowPicker(true)}>+ Pridať z katalógu</BtnAdd>
                <button onClick={() => setNovaPolozka({})} title="Nová položka — uloží sa do katalógu a vloží do tejto ponuky. Jednorazovú prácu označíš v okne." style={{ padding: '7px 14px', border: '1px solid #5b21b6', background: '#f5f3ff', color: '#5b21b6', borderRadius: RADIUS.md, cursor: 'pointer', fontWeight: 800, fontSize: TYPO.sizes.xs, fontFamily: 'inherit' }}>+ Nová položka</button>
              </div>

              {loading ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, textAlign: 'center' }}>Načítavam…</div>
              ) : lines.length === 0 ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, textAlign: 'center' }}>
                  Žiadne položky. Klikni „+ Pridať z katalógu" alebo „+ Nová položka".
                </div>
              ) : (
                <div>
                  {/* Header — CP_LINEROW_GRID_2026-05-28: zhodné s LineRow (9 stĺpcov) */}
                  <div style={{
                    display: 'grid', gridTemplateColumns: '76px 1fr 62px 36px 124px 84px 82px 30px 26px',
                    gap: 4, padding: '6px 10px',
                    background: COLORS.bgSoft, borderBottom: `1px solid ${COLORS.line}`,
                    fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
                    color: COLORS.muted, textTransform: 'uppercase',
                  }}>
                    <div>Foto</div>
                    <div>Položka</div>
                    <div style={{ textAlign: 'right' }}>Množstvo</div>
                    <div style={{ textAlign: 'center' }}>MJ</div>
                    <div style={{ textAlign: 'right' }}>Cena/MJ</div>
                    <div style={{ textAlign: 'center' }}>Hrúbka/Spotreba</div>
                    <div style={{ textAlign: 'right' }}>Spolu</div>
                    <div style={{ display: 'flex', justifyContent: 'center' }} title="Cena spolu alebo zvlášť realizácia a materiál"><NavIcon name="vaha" size={11} /></div>
                    <div></div>
                  </div>
                  {lines.map((l, idx) => (
                    <LineRow onDoKatalogu={(l) => setNovaPolozka({ line: l, predloha: { title: l.title, full_name: l.full_name, unit: l.unit, price: l.price, labor_price: l.labor_price, material_price: l.material_price, material: l.material, thickness: l.thickness || (l.custom_thickness ? String(l.custom_thickness) + ' mm' : ''), consumption: l.consumption || l.custom_consumption || '', description: l.description } })} key={l.id} line={l} idx={idx} count={lines.length} catalog={catalog}
                      onUpdate={updateLine} onDelete={deleteLine} onMove={moveLine} />
                  ))}
                </div>
              )}

              {/* Súčty */}
              {lines.length > 0 && (
                <div style={{
                  padding: SPACE.md, borderTop: `2px solid ${COLORS.line}`,
                  background: COLORS.bgSoft,
                  display: 'flex', alignItems: 'center', flexWrap: 'wrap',
                  justifyContent: 'flex-end', gap: SPACE.xl,
                }}>
                  {/* Variantné položky (Mirko 28.8.): tá istá plocha v rôznych materiáloch — súčet
                      riadkov by zákazníka pomýlil, preto sa dá sumár z PDF vypnúť. Riadky ostávajú. */}
                  <label style={{ marginRight: 'auto', display: 'flex', alignItems: 'center', gap: 8,
                    fontSize: TYPO.sizes.sm, color: COLORS.text,
                    cursor: docLocked ? 'not-allowed' : 'pointer' }}>
                    <input type="checkbox" checked={hideTot} disabled={docLocked || savingTot}
                      onChange={e => toggleHideTotal(e.target.checked)}
                      style={{ margin: 0, cursor: docLocked ? 'not-allowed' : 'pointer' }} />
                    <span>Nezobrazovať celkovú sumu{savingTot ? ' — ukladám…' : ''}</span>
                    <HelpHint text="ČO: schová súčet — tu v editore aj na PDF ponuky (Medzisúčet / DPH / Celková cena). Ceny jednotlivých položiek ostanú, tie zákazník vidí ďalej. PREČO: keď sú v ponuke variantné položky (tá istá plocha v rôznych materiáloch, iná cena za m²), ich súčet je zavádzajúci. KAM: ukladá sa hneď po kliknutí, netreba ✓ Uložiť — over si to cez Náhľad PDF." />
                  </label>
                  {hideTot ? (
                    <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, color: COLORS.muted }}>
                      Celková suma je vypnutá — nezobrazuje sa tu ani na ponuke.
                    </div>
                  ) : (
                    <>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Bez DPH</div>
                        <div style={{ fontFamily: TYPO.mono, fontWeight: TYPO.weights.semibold }}>{SK.eur(subTotal)}</div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>DPH {vatRate}%</div>
                        <div style={{ fontFamily: TYPO.mono, color: COLORS.total }}>+{SK.eur(vatAmt)}</div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Spolu s DPH</div>
                        <div style={{ fontFamily: TYPO.mono, fontSize: TYPO.sizes.lg,
                          fontWeight: TYPO.weights.bold, color: COLORS.brandText }}>{SK.eur(total)}</div>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>

            {/* Príplatky (custom text) · cp_plocha_v1: karta Text k ponuke */}
            <Sekcia nazov="Text k ponuke" style={{ marginBottom: 0 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            <Field label="Príplatky k cene diela (vlastný text)">
              <textarea style={{ ...inp, resize: 'vertical', minHeight: 60 }}
                value={quote.custom_text || ''}
                onChange={e => updField('custom_text', e.target.value)}
                placeholder="Napr.: Murárske prípravné práce sa fakturujú zvlášť podľa skutočnosti." />
            </Field>

            <Field label="Interná poznámka (NIE v PDF)">
              <textarea style={{ ...inp, resize: 'vertical', minHeight: 40 }}
                value={quote.internal_note || ''}
                onChange={e => updField('internal_note', e.target.value)}
                placeholder="Poznámky pre vašu evidenciu — nezobrazia sa v PDF" />
            </Field>
            </div>
            </Sekcia>
          </div>
        )}

        {tab === 'vop' && (
          <VopOverridePanel quote={quote} onChange={vo => updField('vop_override', vo)} />
        )}

        {tab === 'history' && (
          <HistoryPanel module={CFG.resource} entityId={record.id} />
        )}
      </div>

      {showPicker && (
        <CatalogPicker catalog={catalog.filter(c => c.active !== 0)} onPick={pickItem} onClose={() => setShowPicker(false)} />
      )}
      {novaPolozka && (
        <KatalogPolozkaModal zPonuky naviazat={!!novaPolozka.line} predloha={novaPolozka.predloha || null} onClose={() => setNovaPolozka(null)}
          onSaved={async (saved) => {
            const stara = novaPolozka.line; setNovaPolozka(null)
            if (!saved || !saved.id) { reload(); return }
            if (stara) {
              // zaradenie existujúcej vlastnej položky: riadok dostane väzbu na katalóg a obrázok, ceny a množstvo ostávajú
              try {
                const r = await fetchAuth(`/api/quotes/${quote.id}/lines/${stara.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ ...stara, catalog_id: saved.id, image: saved.image || '', title: saved.title || stara.title, full_name: saved.full_name || '', material: saved.material || '', description: saved.description || '', unit: saved.unit || stara.unit }) })   // texty riadku = z katalógu; množstvo a cena ostávajú
                if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || ('HTTP ' + r.status)) }
                toast.success('Položka je v katalógu a riadok ponuky je na ňu naviazaný.')
              } catch (e) { toast.error('Položka je v katalógu, ale riadok sa nenaviazal: ' + e.message) }
              reload()
            } else {
              await pickItem(saved)   // vloží riadok aj s obrázkom a skryje príplatky ako pri výbere z katalógu
            }
          }} />
      )}
      {showPdfPreview && (
        <PdfPreviewModal quote={quote} onClose={() => setShowPdfPreview(false)} />
      )}
      {/* cp_prefill_v1 (Mirko 13. 10. 2026): „mena a priezvisko, telefon, email zadané na obhliadke, dam
          vytvoriť CP, prenesies vsetky polia, zakaznik nový dam vytvoriť nový a polia sú prázdne, to prečo?"
          Obhliadka posiela meno kontaktu do poľa `contact` zlepené s telefónom („Meno · +421…"), telefón
          a e-mail majú vlastné polia. Okno nového zákazníka ich teda vie dostať — len mu ich nikto nedával. */}
      <NoviCustomerDialog
        open={newCustomerOpen}
        prefillName={newCustomerPrefill}
        prefill={{
          // CP_OTVOR_V1: bez mena kontaktu je v `contact` len telef\u00f3n (z obhliadky predvolene \u010d\u00edslo KAMIRu) \u2014 telef\u00f3n nie je meno
          name: newCustomerPrefill || quote.customer_name || (s => /\d{3}/.test(s) ? '' : s)(String(quote.contact || '').split('\u00b7')[0].trim()),
          phone: quote.contact_phone || String(quote.contact || '').split('\u00b7')[1] || '',
          email: quote.contact_email || '',
        }}
        onClose={() => { setNewCustomerOpen(false); setNewCustomerPrefill('') }}
        onCreated={c => {
          setCustomers(prev => [...prev, c])
          updField('customerId', c.id)
          setNewCustomerPrefill('')
        }}
      />
    </div>
  )
}

// inp presunuty do ../components/DocFields.jsx (zdielany, Mirko 27.7.)

// Field presunuty do ../components/DocFields.jsx (zdielany, Mirko 27.7.)

// LINE_ROW_SPLIT_v2 — auto-save debounce + split price (práca + materiál) + lepšia hrúbka
// Šípky poradia položky — vľavo pri obrázku (Mirko 2026-07-14); line-ikony, žiadne emoji (ústava)
function MoveArrows({ canUp, canDown, onMove }) {
  const b = (dis) => ({ width: 20, height: 16, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', border: `1px solid ${COLORS.line}`, borderRadius: 4, cursor: dis ? 'default' : 'pointer', opacity: dis ? 0.25 : 1, color: COLORS.muted })
  const Ch = ({ up }) => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">{up ? <path d="m18 15-6-6-6 6" /> : <path d="m6 9 6 6 6-6" />}</svg>
  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2, marginRight: 4, flexShrink: 0 }}>
      <button type="button" disabled={!canUp} onClick={() => canUp && onMove('up')} title="Posunúť vyššie" style={b(!canUp)}><Ch up /></button>
      <button type="button" disabled={!canDown} onClick={() => canDown && onMove('down')} title="Posunúť nižšie" style={b(!canDown)}><Ch /></button>
    </span>
  )
}

function LineRow({ onDoKatalogu, line, idx, count, catalog, onUpdate, onDelete, onMove }) {
  const [qty, setQty] = useState(line.qty || 0)
  const [price, setPrice] = useState(line.price || 0)
  const [laborPrice, setLaborPrice] = useState(line.labor_price || 0)
  const [materialPrice, setMaterialPrice] = useState(line.material_price || 0)
  const [thickness, setThickness] = useState(line.custom_thickness || line.thickness || '')
  const [consText, setConsText] = useState(line.custom_consumption || '')
  const [priceMode, setPriceMode] = useState(line.price_mode || 'combined')
  const [laborUnit, setLaborUnit] = useState(line.labor_unit || 'm²')
  const [materialUnit, setMaterialUnit] = useState(line.material_unit || 'm³')
  const [editOpen, setEditOpen] = useState(false) // lokálna úprava textov+MJ — len táto CP (Mirko 2026-07-16)
  useEffect(() => {
    setQty(line.qty || 0)
    setPrice(line.price || 0)
    setLaborPrice(line.labor_price || 0)
    setMaterialPrice(line.material_price || 0)
    setThickness(line.custom_thickness || line.thickness || '')
    setPriceMode(line.price_mode || 'combined')
    setLaborUnit(line.labor_unit || 'm²')
    setMaterialUnit(line.material_unit || 'm³')
  }, [line.id])

  const cat = catalog.find(c => c.id === line.catalog_id)

  // Hrúbka v mm — parsing zo stringu (môže byť "60", "60 mm", "0,06 m" atď.)
  const parseThicknessMm = (t) => {
    if (!t) return 0
    const s = String(t).replace(',', '.').trim()
    const isMeters = /\bm\b|^\d+[.,]\d+$/.test(s) && !s.toLowerCase().includes('mm')
    const n = parseFloat(s.replace(/[^\d.-]/g, ''))
    if (!isFinite(n)) return 0
    return isMeters && n < 10 ? n * 1000 : n  // ak "0.06" → 60 mm; ak "60" → 60 mm
  }
  // Materiálový prepočet — ústava sek. 21.6.A (Mirko 2026-05-27)
  // Tri módy z katalógovej položky: 'fixed' (€/m²) | 'kg' (€/t × kg/m²/mm × hrúbka) | 'm3' (€/m³ × hrúbka)
  const hrubkaMm = parseThicknessMm(thickness)
  const calcMode = cat?.material_calc_mode || (materialUnit === 'm³' || materialUnit === 'm3' ? 'm3' : 'fixed')
  const isM3 = calcMode === 'm3'
  const isKg = calcMode === 'kg'
  // materialPrice je override v line; ak je 0, fallback do katalógu
  const effectiveUnitPrice = Number(materialPrice) > 0 ? Number(materialPrice) : (Number(cat?.material_price) || 0)
  const consumptionKg = Number(cat?.consumption_kg_per_m2_per_mm) || 0
  let effectiveMaterial
  if (isKg && consumptionKg > 0 && hrubkaMm > 0) {
    // Sádra: kg/m²/mm × hrúbka × (€/tona / 1000) = €/m²
    effectiveMaterial = consumptionKg * hrubkaMm * (effectiveUnitPrice / 1000)
  } else if (isM3 && hrubkaMm > 0) {
    // Anhydrit: €/m³ × hrúbka/1000 = €/m²
    effectiveMaterial = effectiveUnitPrice * (hrubkaMm / 1000)
  } else {
    // Pevná cena €/m² — bez prepočtu (default)
    effectiveMaterial = effectiveUnitPrice
  }

  // Pri split mode = práca + materiál_per_m² (po prepočte cez hrúbku ak je kg/m3)
  const unitPrice = priceMode === 'split'
    ? (Number(laborPrice) || 0) + effectiveMaterial
    : (Number(price) || 0)
  // cp_split_v2 — rovnako ako PDF ponuky: množstvo 0 = 1; materiál v m³ = objem (m² × hrúbka, pri ≤ 1 m² alebo bez hrúbky 1 m³)
  const qtyN = Number(qty) > 0 ? Number(qty) : 1
  const objemM3 = (priceMode === 'split' && isM3) ? ((hrubkaMm > 0 && qtyN > 1) ? qtyN * hrubkaMm / 1000 : 1) : 0
  const total = (priceMode === 'split' && isM3)
    ? (Number(laborPrice) || 0) * qtyN + objemM3 * effectiveUnitPrice
    : qtyN * unitPrice

  // Recalc OKAMŽITE — onUpdate spraví instant merge v parentovi (riadok aj dolný súčet),
  // PUT je debounced v parentovi (Mirko 2026-06-03 „neprepočítava")
  function scheduleSave(changes) { onUpdate(line, changes) }

  function changeQty(v) {
    setQty(v)
    // cp_split_v2 (Mirko: „nedovoľ 0, ak nie je množstvo dáš 1“)
    scheduleSave({ qty: Number(v) > 0 ? Number(v) : 1 })
  }
  function changePrice(v) {
    setPrice(v)
    scheduleSave({ price: Number(v) || 0 })
  }
  // Helper: effective total cez prepočet m³ × hrúbka (Mirko 2026-05-27)
  function calcEffectiveTotal(labor, material) {
    const mat = (isM3 && hrubkaMm > 0)
      ? (Number(material) || 0) * (hrubkaMm / 1000)
      : (Number(material) || 0)
    return (Number(labor) || 0) + mat
  }
  function changeLaborPrice(v) {
    setLaborPrice(v)
    scheduleSave({ labor_price: Number(v) || 0, price: calcEffectiveTotal(v, materialPrice) })
  }
  function changeMaterialPrice(v) {
    setMaterialPrice(v)
    scheduleSave({ material_price: Number(v) || 0, price: calcEffectiveTotal(laborPrice, v) })
  }
  function changeLaborUnit(u) {
    setLaborUnit(u)
    scheduleSave({ labor_unit: u })
  }
  function changeMaterialUnit(u) {
    setMaterialUnit(u)
    scheduleSave({ material_unit: u })
  }
  function changeThickness(t) {
    setThickness(t)
    // PRVE cislo z textu — NIE zretazenie vsetkych cislic ("do hrubky 20 28kg/m2" -> 20282 -> 1298 kg/m2; Mirko 16.8.)
    const tNum = parseFloat(((String(t).match(/\d+(?:[.,]\d+)?/) || ['0'])[0]).replace(',', '.')) || 0
    const changes = { custom_thickness: t }
    // Automatika LEN ak je v katalogu zapnuta (auto_consumption checkbox) a spotreba NIE je zadana rucne
    const autoOn = cat && Number(cat.auto_consumption ?? 1) !== 0
    const consNow = String(consText || '')
    const isAutoTxt = consNow === '' || /^cca [\d.,]+ kg\/m²$/.test(consNow)
    if (autoOn && isAutoTxt && tNum > 0) {
      const perMm = (Number(cat.consumption_kg_per_m2_per_mm) || 0)
        || (cat.base_thickness_mm > 0 ? (Number(cat.base_consumption_val) || 0) / cat.base_thickness_mm : 0)
      if (perMm > 0) {
        const auto = `cca ${(perMm * tNum).toFixed(2)} kg/m²`
        changes.custom_consumption = auto
        setConsText(auto)
      }
    }
    // Pre poter/anhydrit m³ × hrúbka — pri zmene hrúbky aktualizuj effective price
    if (priceMode === 'split' && (materialUnit === 'm³' || materialUnit === 'm3')) {
      const newHrubkaMm = parseThicknessMm(t)
      const newMatPerM2 = newHrubkaMm > 0 ? (Number(materialPrice) || 0) * (newHrubkaMm / 1000) : (Number(materialPrice) || 0)
      changes.price = (Number(laborPrice) || 0) + newMatPerM2
    }
    scheduleSave(changes)
  }
  function changeConsumption(v) {
    setConsText(v)
    scheduleSave({ custom_consumption: v })
  }
  function togglePriceMode() {
    const newMode = priceMode === 'combined' ? 'split' : 'combined'
    setPriceMode(newMode)
    if (newMode === 'split' && (laborPrice + materialPrice === 0) && price > 0) {
      // Pri prepnutí na split — defaultne rozdeľ 50/50 (Mirko si potom upraví)
      const half = Math.round((Number(price) || 0) * 50) / 100
      setLaborPrice(half)
      setMaterialPrice(half)
      onUpdate(line, { price_mode: newMode, labor_price: half, material_price: half })
    } else if (newMode === 'combined') {
      // Mirko 2026-05-27: pri spojení zachovaj effective €/m² (unitPrice už počíta cez hrúbku pre m³)
      const effective = Number(unitPrice.toFixed(2))
      setPrice(effective)
      onUpdate(line, { price_mode: newMode, price: effective })
    } else {
      onUpdate(line, { price_mode: newMode })
    }
  }

  return (
    <div style={{
      // CP_LINEROW_GRID_2026-05-28 (Mirko): 9 stĺpcov — toggle ⚖ má vlastný stĺpec bokom (NIE v cene)
      display: 'grid', gridTemplateColumns: '76px 1fr 62px 36px 124px 84px 82px 30px 26px',
      gap: 4, padding: '6px 10px',
      borderBottom: `1px solid ${COLORS.lineSoft || COLORS.line}`,
      background: idx % 2 ? COLORS.bgSoft : 'transparent',
      alignItems: 'center', fontSize: TYPO.sizes.sm,
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <MoveArrows canUp={idx > 0} canDown={idx < count - 1} onMove={(dir) => onMove(line, dir)} />
        {line.image
          ? <img src={`/uploads/${line.image}?t=${Date.now()}`} alt="" style={{
              width: 44, height: 44, objectFit: 'cover',
              borderRadius: RADIUS.sm, border: `1px solid ${COLORS.line}`,
            }} />
          : <div style={{ width: 44, height: 44, background: COLORS.bgSoft,
              border: `1px dashed ${COLORS.line}`, borderRadius: RADIUS.sm,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 16, color: COLORS.muted }}><NavIcon name="fotky" size={18} /></div>}
      </div>
      <div>
        <div style={{ fontWeight: TYPO.weights.semibold }}>{line.title}</div>
        {line.full_name && line.full_name !== line.title && (
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.text, marginTop: 2, whiteSpace: 'pre-wrap', lineHeight: 1.4 }}>{line.full_name}</div>
        )}
        {line.material && (
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontStyle: 'italic' }}>{line.material}</div>
        )}
        {line.description && (
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 3, whiteSpace: 'pre-wrap', lineHeight: 1.4 }}>{line.description}</div>
        )}
      </div>
      <div>
        <input style={{ ...inp, padding: '4px 6px', textAlign: 'right', fontFamily: TYPO.mono }}
          type="number" step="0.01" min="0.01" value={qty}
          onChange={e => changeQty(e.target.value)}
          onBlur={() => { if (!(Number(qty) > 0)) setQty(1) }} />
      </div>
      <div style={{ textAlign: 'center', color: COLORS.muted, fontSize: TYPO.sizes.xs }}>
        {priceMode === 'split' ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <input style={{ ...inp, padding: '2px 4px', textAlign: 'center', fontSize: 10, width: '100%' }}
              value={laborUnit} onChange={e => changeLaborUnit(e.target.value)} title="MJ pre realizáciu" />
            <input style={{ ...inp, padding: '2px 4px', textAlign: 'center', fontSize: 10, width: '100%' }}
              value={materialUnit} onChange={e => changeMaterialUnit(e.target.value)} title="MJ pre materiál" />
          </div>
        ) : line.unit}
      </div>

      {/* Cena — combined alebo split. CP_LINEROW_GRID_2026-05-28 (Mirko): NO toggle inline, inputs plnia celý stĺpec rovnako */}
      <div>
        {priceMode === 'combined' ? (
          <input style={{ ...inp, padding: '4px 6px', textAlign: 'right', fontFamily: TYPO.mono, width: '100%' }}
            type="number" step="0.01" value={price}
            onChange={e => changePrice(e.target.value)}
            title="Spojená cena (realizácia + materiál spolu)" />
        ) : (
          // Split layout — realizácia/mat. (p96, Mirko 21. 9. 2026: „práca“ → „realizácia“) labels vľavo, inputy vpravo, rovnaká šírka (Mirko 2026-05-28 čisté línie)
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <span style={{ fontSize: 9, color: COLORS.muted, width: 54, flexShrink: 0, fontFamily: TYPO.mono }}>realizácia</span>
              <input style={{ ...inp, padding: '2px 4px', textAlign: 'right', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, flex: 1, minWidth: 0 }}
                type="number" step="0.01" value={laborPrice}
                onChange={e => changeLaborPrice(e.target.value)} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <span style={{ fontSize: 9, color: COLORS.muted, width: 54, flexShrink: 0, fontFamily: TYPO.mono }}>materiál</span>
              <input style={{ ...inp, padding: '2px 4px', textAlign: 'right', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, flex: 1, minWidth: 0 }}
                type="number" step="0.01" value={materialPrice}
                onChange={e => changeMaterialPrice(e.target.value)} />
            </div>
          </div>
        )}
      </div>

      {/* Hrúbka + spotreba — jednotka mm explicitne (Mirko 2026-06-03) */}
      <div>
        <div style={{ fontSize: 9, color: COLORS.muted, fontWeight: TYPO.weights.bold, marginBottom: 1, letterSpacing: '.02em' }}>HRÚBKA (mm)</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <input style={{ ...inp, padding: '4px 6px', fontSize: TYPO.sizes.xs, flex: 1, minWidth: 0, textAlign: 'right', fontFamily: TYPO.mono }}
            value={thickness} placeholder={cat?.base_thickness_mm ? String(cat.base_thickness_mm) : '50'}
            onChange={e => changeThickness(e.target.value)}
            title={cat && cat.base_thickness_mm ? `Norma: ${cat.base_consumption_val} kg/m² pri ${cat.base_thickness_mm} mm` : 'Zadaj hrúbku v mm (napr. 50)'} />
          <span style={{ fontSize: 10, color: COLORS.muted, fontFamily: TYPO.mono }}>mm</span>
        </div>
        {(isM3 || isKg) && hrubkaMm <= 0 && (
          <div style={{ fontSize: 9, color: '#b45309', marginTop: 2, fontWeight: TYPO.weights.bold }}>zadaj hrúbku</div>
        )}
        <input style={{ ...inp, padding: '2px 4px', fontSize: 10, marginTop: 2, width: '100%', fontFamily: TYPO.mono }}
          value={consText} placeholder={line.consumption || 'spotreba — napr. cca 28 kg/m²'}
          onChange={e => changeConsumption(e.target.value)}
          title="Spotreba materialu (text na PDF). Rucny zapis ma prednost — automatika ho NIKDY neprepise." />
      </div>

      <div style={{ textAlign: 'right', fontFamily: TYPO.mono }}>
        <div style={{ fontWeight: TYPO.weights.bold }}>{SK.eur(total)}</div>
        {/* Effective hint pri split+m³ — namiesto zaberania miesta v Cena bunke (Mirko 2026-05-27) */}
        {/* cp_split_v2 — bez zmiešanej ceny za m²; realizácia a materiál zvlášť ako na PDF ponuky */}
        {priceMode === 'split' && isM3 && (
          <div style={{ fontSize: 9, color: COLORS.muted, marginTop: 1, lineHeight: 1.35 }}
            title={hrubkaMm > 0 && qtyN > 1 ? `${qtyN} m² × ${hrubkaMm} mm = ${objemM3.toLocaleString('sk-SK', { maximumFractionDigits: 2 })} m³` : 'bez hrúbky alebo pri 1 m² sa materiál počíta za 1 m³'}>
            <div>real. {SK.eur((Number(laborPrice) || 0) * qtyN)}</div>
            <div>mat. {objemM3.toLocaleString('sk-SK', { maximumFractionDigits: 2 })} m³ × {SK.eur(effectiveUnitPrice)}</div>
          </div>
        )}
      </div>
      {/* Toggle ⚖ — vlastný stĺpec bokom, nezasahuje do cenového stĺpca (Mirko 2026-05-28) */}
      <div style={{ textAlign: 'center' }}>
        <button onClick={togglePriceMode}
          title={priceMode === 'combined' ? 'Rozdeliť na realizáciu + materiál' : 'Spojiť do jednej ceny (zachová €/m²)'}
          style={{ background: COLORS.brand, border: `1px solid ${COLORS.brand}`, borderRadius: RADIUS.sm,
            cursor: 'pointer', padding: '4px 6px', fontSize: 13, fontWeight: 700, color: '#fff',
            fontFamily: 'inherit', boxShadow: '0 1px 2px rgba(29,78,216,0.35)', lineHeight: 1 }}><NavIcon name="vaha" size={14} /></button>
      </div>
      <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <button onClick={() => setEditOpen(true)} title="Upraviť texty a MJ — platí len pre túto ponuku"
          style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: COLORS.nav, fontSize: 15, padding: 4 }}>✎</button>
        <button onClick={() => onDelete(line)}
          style={{ background: 'transparent', border: 'none', cursor: 'pointer',
            color: COLORS.remove, fontSize: 16, padding: 4 }} title="Zmazať položku"><NavIcon name="kos" size={16} /></button>
      </div>
      {editOpen && <LineEditModal line={line} onClose={() => setEditOpen(false)}
        onSave={(ch) => { onUpdate(line, ch); setEditOpen(false) }}
        onDoKatalogu={onDoKatalogu ? (f) => { onUpdate(line, f); setEditOpen(false); onDoKatalogu({ ...line, ...f }) } : null} />}
    </div>
  )
}

// Lokálna úprava riadku CP — všetky texty + MJ, ukladá sa LEN do quote_lines tejto ponuky (katalóg nedotknutý).
// Obrázok sa needituje (Mirko 2026-07-16). Hrúbka/množstvo/ceny ostávajú inline v riadku.
function LineEditModal({ line, onClose, onSave, onDoKatalogu }) {
  const [f, setF] = useState({
    title: line.title || '', full_name: line.full_name || '', material: line.material || '',
    description: line.description || '', unit: line.unit || 'm²', consumption: line.consumption || '',
  })
  const set = (k, v) => setF(s => ({ ...s, [k]: v }))
  const inpS = { width: '100%', padding: '7px 10px', border: '1px solid ' + COLORS.line, borderRadius: RADIUS.sm,
    fontSize: TYPO.sizes.sm, fontFamily: 'inherit', boxSizing: 'border-box' }
  const lbl = { fontSize: TYPO.sizes.xs, color: COLORS.muted, margin: '8px 0 3px', fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.03em' }
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: SPACE.md }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 560, maxWidth: '100%', maxHeight: '90vh', overflow: 'auto',
        background: COLORS.bg, borderRadius: RADIUS.lg, padding: SPACE.lg }}>
        <h3 style={{ margin: 0, marginBottom: 4 }}>Upraviť položku</h3>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: SPACE.sm }}>Zmeny platia len pre túto cenovú ponuku — katalóg sa nemení.</div>
        {!line.catalog_id && onDoKatalogu && (
          <div style={{ background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: RADIUS.md, padding: SPACE.sm, marginBottom: SPACE.sm, fontSize: TYPO.sizes.sm, display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap' }}>
            <span style={{ flex: 1 }}>Táto položka <b>nie je v katalógu</b> — nabudúce ju nikto nenájde a nemá obrázok.</span>
            <button onClick={() => onDoKatalogu(f)} style={{ padding: '6px 12px', border: 'none', background: COLORS.nav, color: '#fff', borderRadius: RADIUS.sm, cursor: 'pointer', fontSize: TYPO.sizes.sm, fontFamily: 'inherit', fontWeight: 700 }}>Uložiť do katalógu</button>
          </div>
        )}
        <div style={lbl}>Názov</div>
        <input value={f.title} onChange={e => set('title', e.target.value)} style={inpS} />
        <div style={lbl}>Podnázov (dlhý názov pod titulom)</div>
        <textarea value={f.full_name} onChange={e => set('full_name', e.target.value)} rows={2} style={{ ...inpS, resize: 'vertical' }} />
        <div style={lbl}>Materiál (kurzívový riadok)</div>
        <input value={f.material} onChange={e => set('material', e.target.value)} style={inpS} />
        <div style={lbl}>Popis</div>
        <textarea value={f.description} onChange={e => set('description', e.target.value)} rows={4} style={{ ...inpS, resize: 'vertical' }} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: SPACE.sm }}>
          <div>
            <div style={lbl}>MJ (merná jednotka)</div>
            <input value={f.unit} onChange={e => set('unit', e.target.value)} list="mj-options" style={inpS} />
            <datalist id="mj-options">
              {['m²', 'bm', 'hod', 'ks', 'kpl', 'm', 'm³', 't', 'kg', 'deň'].map(u => <option key={u} value={u} />)}
            </datalist>
          </div>
          <div>
            <div style={lbl}>Spotreba (text pod hrúbkou)</div>
            <input value={f.consumption} onChange={e => set('consumption', e.target.value)} style={inpS} placeholder="napr. cca 4,0 kg/m² (v cene)" />
          </div>
        </div>
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end', marginTop: SPACE.md }}>
          <button onClick={onClose} style={{ padding: '8px 16px', border: '1px solid ' + COLORS.line, background: '#fff',
            borderRadius: RADIUS.md, fontSize: TYPO.sizes.sm, cursor: 'pointer', fontFamily: 'inherit' }}>Zrušiť</button>
          <button onClick={() => onSave(f)} style={{ padding: '8px 16px', border: 'none', background: COLORS.brand, color: '#fff',
            borderRadius: RADIUS.md, fontSize: TYPO.sizes.sm, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 700 }}>✓ Uložiť</button>
        </div>
      </div>
    </div>
  )
}

function CatalogPicker({ catalog, onPick, onClose }) {
  const [search, setSearch] = useState('')
  const [trade, setTrade] = useState('all')
  const TRADES_PICK = [
    { k: 'all', l: 'Všetky' }, { k: 'omietky', l: 'Omietky' },
    { k: 'potery', l: 'Potery' }, { k: 'maliarske', l: 'Maľovanie' },
    { k: 'zateplenie', l: 'Zateplenie' }, { k: 'ine', l: 'Iné' },   // cp_polozka_v1
  ]
  const filtered = catalog.filter(c => {
    if (trade !== 'all' && (c.trade || c.category) !== trade) return false
    if (search.trim()) {
      const q = search.toLowerCase()
      return hladaj((c.title || ''), q)
          || hladaj((c.material || ''), q)
          || hladaj((c.id || ''), q)
    }
    return true
  })
  return (
    <Modal open title="Vyber položku z katalógu" onClose={onClose} width={900}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md, maxHeight: '70vh' }}>
        <div style={{ display: 'flex', gap: SPACE.sm }}>
          <input style={{ ...inp, flex: 1 }} value={search} onChange={e => setSearch(e.target.value)}
            placeholder="Hľadať (názov / materiál / ID)…" autoFocus />
        </div>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Nenašiel si ju? Zavri a klikni <b>+ Nová položka</b> — uloží sa do katalógu aj do ponuky. {/* cp_polozka_v1 */}</div>
        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
          {TRADES_PICK.map(t => (
            <button key={t.k} onClick={() => setTrade(t.k)} style={{
              padding: '4px 10px',
              background: trade === t.k ? COLORS.navBg : 'transparent',
              border: `1px solid ${trade === t.k ? COLORS.brand : COLORS.line}`,
              borderRadius: RADIUS.full, cursor: 'pointer',
              fontSize: TYPO.sizes.xs, color: trade === t.k ? COLORS.brand : COLORS.muted,
              fontFamily: 'inherit',
            }}>{t.l}</button>
          ))}
        </div>
        <div style={{ overflow: 'auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.sm }}>
          {filtered.map(c => (
            <div key={c.id} onClick={() => onPick(c)} style={{
              padding: SPACE.sm, background: COLORS.bg,
              border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
              display: 'flex', gap: SPACE.sm, cursor: 'pointer',
            }}
              onMouseEnter={e => e.currentTarget.style.background = COLORS.bgSoft}
              onMouseLeave={e => e.currentTarget.style.background = COLORS.bg}>
              {c.image
                ? <img src={`/uploads/${c.image}`} alt="" style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: RADIUS.sm }} />
                : <div style={{ width: 56, height: 56, background: COLORS.bgSoft,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    borderRadius: RADIUS.sm, fontSize: 22, color: COLORS.muted }}><NavIcon name="fotky" size={22} /></div>}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.sm,
                  whiteSpace: 'normal', wordBreak: 'break-word' }}>{c.title}</div>
                <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontStyle: 'italic',
                  whiteSpace: 'normal', wordBreak: 'break-word' }}>{c.material || ''}</div>
                {c.description && (
                  <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.text, marginTop: 3, whiteSpace: 'pre-wrap',
                    lineHeight: 1.35, maxHeight: 80, overflow: 'auto' }}>{c.description}</div>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4, fontSize: TYPO.sizes.xs }}>
                  <span style={{ color: COLORS.muted }}>{c.unit} · {c.thickness}</span>
                  <span style={{ fontFamily: TYPO.mono, fontWeight: TYPO.weights.bold }}>{SK.eur(c.price)}</span>
                </div>
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{ gridColumn: 'span 2', padding: SPACE.lg, color: COLORS.muted, textAlign: 'center' }}>
              Žiadne položky. Pridaj nové do <strong>Katalógy → CP katalóg</strong>.
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

// VOP_NASTAVENIA_NEMENNE 2026-07-27 (Mirko GO — ÚSTAVNÁ): globálny katalóg vop_items sa edituje
// VÝHRADNE v Nastavenia → VOP (VopTab v NastaveniaView.jsx). CP obrazovka už NESMIE meniť/mazať/pridávať
// do zdieľaného katalógu — VopEditRow (PUT/DELETE /api/vop-items) a editMode boli preto z CP odstránené.
// Jediná cesta na zmenu textu z CP je "Upraviť pre CP" nižšie — mení VÝHRADNE quote.vop_override.
function VopOverridePanel({ quote, onChange }) {
  const [vopItems, setVopItems] = useState([])
  const [loading, setLoading] = useState(true)
  // VOP_PER_CP_TEXT 2026-07-27 (Mirko GO): úprava textu bodu PRE TÚTO CP nesmie zmeniť globálny katalóg
  // (predtým "Upraviť VOP" volalo PUT /api/vop-items/:id → menilo text vo VŠETKÝCH ponukách).
  // Riešenie: quote.vop_override môže niesť {id, text} objekt — backend (buildEffectiveVop) to už podporoval,
  // len frontend to nikdy nepoužíval na editáciu. Ostatné CP zostávajú štandardné, mení sa LEN táto ponuka.
  const [customizeId, setCustomizeId] = useState(null)
  const [customizeText, setCustomizeText] = useState('')
  const override = (() => {
    try { return JSON.parse(quote.vop_override || '[]') } catch { return [] }
  })()
  // off = položka je pre TÚTO CP vypnutá. Objekt bez enabled:false = ZAPNUTÝ s vlastným textom (zhoda s backend buildEffectiveVop).
  const ovEntryFor = (id) => override.find(o => (o && typeof o === 'object') ? o.id === id : o === id)
  const isOffFor = (id) => {
    const ov = ovEntryFor(id)
    if (ov === undefined) return false
    return (ov && typeof ov === 'object') ? ov.enabled === false : true
  }
  const customTextFor = (id) => {
    const ov = ovEntryFor(id)
    return (ov && typeof ov === 'object' && ov.text != null) ? ov.text : null
  }

  // STRANA_VOP 29. 9. 2026 (Mirko): v ktorom stĺpci PDF bod stojí — LEN pre túto ponuku.
  // Ukladá sa do quote.vop_override ako {id, strana}; globálny katalóg sa nemení (ústava 27.7).
  const stranaFor = (id) => {
    const ov = ovEntryFor(id)
    return (ov && typeof ov === 'object' && ov.strana) ? ov.strana : ''
  }
  // Záznam, ktorý už nič nedrží (bez strany, bez textu, zapnutý) je zbytočný — nech override nerastie.
  const jePrazdnyZapis = (o) => o && typeof o === 'object' && !o.strana && o.text == null
    && o.enabled !== false && !String(o.id).startsWith('custom_')
  function nastavStranu(id, strana) {
    const idx = override.findIndex(o => (o && typeof o === 'object') ? o.id === id : o === id)
    const next = [...override]
    if (idx === -1) next.push({ id, strana })
    else {
      const e = next[idx]
      // holé ID v override znamená VYPNUTÝ bod — pri prepise na objekt to treba udržať
      next[idx] = (e && typeof e === 'object') ? { ...e, strana } : { id, enabled: false, strana }
    }
    onChange(JSON.stringify(next.filter(o => !jePrazdnyZapis(o))))
  }

  // Vlastné body príplatkov — existujú LEN v tejto ponuke (v PDF v bloku „Príplatky k cene diela").
  const vlastneBody = override.filter(o => o && typeof o === 'object' && String(o.id).startsWith('custom_'))
  function pridajVlastnyBod() {
    const id = 'custom_' + Date.now().toString(36)
    onChange(JSON.stringify([...override, { id, text: '', strana: '', enabled: true }]))
  }
  function zmenVlastnyBod(id, zmena) {
    onChange(JSON.stringify(override.map(o =>
      (o && typeof o === 'object' && o.id === id) ? { ...o, ...zmena } : o)))
  }
  function zmazVlastnyBod(id) {
    onChange(JSON.stringify(override.filter(o => !(o && typeof o === 'object' && o.id === id))))
  }

  const loadVop = () => {
    fetchAuth('/api/vop-items').then(r => r.ok ? r.json() : []).then(d => {
      setVopItems(Array.isArray(d) ? d : [])
      setLoading(false)
    }).catch(() => setLoading(false))
  }
  useEffect(() => { loadVop() }, [])

  function toggle(id) {
    const idx = override.findIndex(o => (o && typeof o === 'object') ? o.id === id : o === id)
    if (idx === -1) { onChange(JSON.stringify([...override, id])); return }
    const entry = override[idx]
    if (entry && typeof entry === 'object') {
      // má vlastný text pre túto CP — prepni enabled, text zachovaj
      const next = [...override]
      next[idx] = { ...entry, enabled: entry.enabled === false ? true : false }
      onChange(JSON.stringify(next))
    } else {
      onChange(JSON.stringify(override.filter((_, i) => i !== idx)))
    }
  }

  function openCustomize(item) {
    setCustomizeId(item.id)
    setCustomizeText(customTextFor(item.id) ?? item.text)
  }
  function saveCustomize(item) {
    const trimmed = customizeText.trim()
    const rest = override.filter(o => (o && typeof o === 'object' ? o.id : o) !== item.id)
    const strana = stranaFor(item.id)   // zvolený stĺpec prežije úpravu textu
    if (trimmed === (item.text || '').trim()) {
      // zhodné so štandardom → zruš úpravu textu (stranu nechaj, ak je zvolená)
      onChange(JSON.stringify(strana ? [...rest, { id: item.id, strana }] : rest))
    } else {
      onChange(JSON.stringify([...rest, { id: item.id, text: trimmed, ...(strana ? { strana } : {}) }]))
    }
    setCustomizeId(null)
  }
  function resetCustomize(item) {
    const rest = override.filter(o => (o && typeof o === 'object' ? o.id : o) !== item.id)
    onChange(JSON.stringify(rest))
    setCustomizeId(null)
  }
  // VOP_NUMBERED_PREVIEW — zoskupené per trade+category (zhoda s PDF generatorom)
  // Trade poradie: spolocne → omietky → potery → maliarske → zateplenie (Mirkove pravidlo)
  const TRADE_ORDER = ['spolocne', 'omietky', 'potery', 'maliarske', 'zateplenie']
  const TRADE_LABELS = {
    spolocne:   { label: 'Spoločné — Platí pre všetky cenové ponuky', color: '#374151' },
    omietky:    { label: 'Omietky',    color: '#22c55e' },
    potery:     { label: 'Potery',     color: '#3b82f6' },
    maliarske:  { label: 'Maľovanie',  color: '#ec4899' },
    zateplenie: { label: 'Zateplenie', color: '#3b82f6' },
  }
  const CATEGORY_LABELS = {
    volitelne: { label: 'Bežné body',                       numbered: true,  hint: 'Číslované 1, 2, 3… v PDF' },
    nemenne:   { label: 'Podmienky prípravy podkladu',      numbered: false, hint: 'Bez čísel (text formátovaný)' },
    priplatky: { label: 'Príplatky',                        numbered: false, hint: 'Bez čísel — bullets •' },
  }

  // grouped[trade][category] = [items]
  const grouped = {}
  vopItems.forEach(v => {
    const t = v.trade || 'spolocne'
    const c = v.category || 'volitelne'
    if (!grouped[t]) grouped[t] = {}
    if (!grouped[t][c]) grouped[t][c] = []
    grouped[t][c].push(v)
  })

  if (loading) return <div style={{ padding: SPACE.lg, color: COLORS.muted }}>Načítavam VOP…</div>

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      <div style={{
        padding: SPACE.sm, background: 'rgba(59,130,246,0.06)',
        border: '1px solid rgba(59,130,246,0.3)', borderRadius: RADIUS.sm,
        fontSize: TYPO.sizes.xs, color: COLORS.muted,
      }}>
        Vypnuté body sa neobjavia v PDF tejto CP. <strong>Default</strong> = všetky aktívne body z Nastavení.
        Pre <strong>Bežné body</strong> sa zobrazia čísla, pre <strong>Príplatky</strong> a <strong>Podmienky</strong> bullets — presne ako v PDF.
        Tlačidlo <strong>„Upraviť pre CP"</strong> zmení text LEN v tejto ponuke — ostatné CP zostanú štandardné.
        Správa spoločného katalógu = <strong>Nastavenia → VOP</strong> (nemenné odtiaľto — ústava).
        Pri príplatkoch sa dá zvoliť <strong>stĺpec v PDF</strong> (V = vľavo, P = vpravo, A = automaticky)
        a dole pridať <strong>vlastný bod len pre túto ponuku</strong>.
      </div>

      {TRADE_ORDER.filter(t => grouped[t]).map(trade => {
        const themeColor = TRADE_LABELS[trade].color
        return (
          <div key={trade} style={{
            background: COLORS.bg, border: `1.5px solid ${themeColor}33`,
            borderLeft: `4px solid ${themeColor}`,
            borderRadius: RADIUS.md, overflow: 'hidden',
          }}>
            <div style={{
              padding: '8px 12px', background: themeColor + '15',
              fontWeight: TYPO.weights.bold, color: themeColor,
              fontSize: TYPO.sizes.sm, textTransform: 'uppercase', letterSpacing: '0.06em',
            }}>{TRADE_LABELS[trade].label}</div>

            {['volitelne', 'nemenne', 'priplatky'].filter(c => grouped[trade][c]?.length).map(category => {
              const catItems = grouped[trade][category]
              const catMeta = CATEGORY_LABELS[category]
              return (
                <div key={category} style={{ padding: SPACE.sm, borderTop: `1px solid ${COLORS.lineSoft || COLORS.line}` }}>
                  <div style={{
                    fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
                    color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.04em',
                    marginBottom: SPACE.xs,
                  }}>{catMeta.label} <span style={{ fontWeight: TYPO.weights.normal, fontStyle: 'italic', textTransform: 'none' }}>· {catMeta.hint}</span></div>
                  {catItems.map((it, idx) => {
                    const off = isOffFor(it.id)
                    const customText = customTextFor(it.id)
                    const displayText = customText != null ? customText : it.text
                    if (customizeId === it.id) return (
                      <div key={it.id} style={{ padding: '4px 4px', display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: TYPO.weights.bold }}>Text len pre túto ponuku — ostatné CP zostanú štandardné:</div>
                        <textarea value={customizeText} onChange={e => setCustomizeText(e.target.value)} rows={3}
                          style={{ fontSize: TYPO.sizes.sm, padding: '5px 8px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }} />
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button onClick={() => saveCustomize(it)} style={{ padding: '5px 10px', fontSize: TYPO.sizes.xs, fontWeight: 700, borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit', border: 'none', background: COLORS.add, color: '#fff' }}>Uložiť (len táto CP)</button>
                          <button onClick={() => setCustomizeId(null)} style={{ padding: '5px 10px', fontSize: TYPO.sizes.xs, fontWeight: 700, borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit', border: `1px solid ${COLORS.line}`, background: '#fff', color: COLORS.text }}>Zrušiť</button>
                          {customText != null && <button onClick={() => resetCustomize(it)} style={{ padding: '5px 10px', fontSize: TYPO.sizes.xs, fontWeight: 700, borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit', border: `1px solid ${COLORS.remove || '#dc2626'}`, background: '#fff', color: COLORS.remove || '#dc2626' }}>Obnoviť štandardný text</button>}
                        </div>
                      </div>
                    )
                    return (
                      <div key={it.id} style={{ display: 'flex', gap: SPACE.sm, alignItems: 'flex-start', padding: '4px 4px' }}>
                        <label style={{ display: 'flex', gap: SPACE.sm, alignItems: 'flex-start', cursor: 'pointer', opacity: off ? 0.5 : 1, flex: 1, minWidth: 0 }}>
                          <input type="checkbox" checked={!off} onChange={() => toggle(it.id)} style={{ marginTop: 2 }} />
                          <span style={{
                            fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs,
                            color: catMeta.numbered ? themeColor : COLORS.muted,
                            fontWeight: TYPO.weights.bold, minWidth: 24,
                          }}>{catMeta.numbered ? `${idx + 1}.` : '•'}</span>
                          <span style={{ fontSize: TYPO.sizes.sm, textDecoration: off ? 'line-through' : 'none', flex: 1 }}>
                            {displayText.length > 200
                              ? <details><summary style={{ cursor: 'pointer' }}>{displayText.substring(0, 180)}… <em style={{ color: themeColor }}>(rozbaliť celé)</em></summary><div style={{ marginTop: 4 }}>{displayText}</div></details>
                              : displayText}
                            {customText != null && <span style={{ marginLeft: 6, fontSize: 10.5, fontStyle: 'italic', color: COLORS.brand }}>(upravené len pre túto CP)</span>}
                          </span>
                        </label>
                        {category === 'priplatky' && (
                          <StranaPrepinac hodnota={stranaFor(it.id)} onChange={s => nastavStranu(it.id, s)} />
                        )}
                        <button type="button" onClick={() => openCustomize(it)} title="Upraviť text len pre túto cenovú ponuku" style={{ flexShrink: 0, padding: '2px 8px', fontSize: 10.5, fontWeight: 700, borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit', border: `1px solid ${COLORS.line}`, background: '#fff', color: COLORS.muted }}>Upraviť pre CP</button>
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        )
      })}

      {/* VLASTNÉ PRÍPLATKY — existujú LEN v tejto ponuke (Mirko 29. 9. 2026).
          Nezapisujú sa do spoločného katalógu, takže ostatné CP zostávajú nedotknuté. */}
      <div style={{
        background: COLORS.bg, border: `1.5px solid ${COLORS.brand}44`,
        borderLeft: `4px solid ${COLORS.brand}`, borderRadius: RADIUS.md, overflow: 'hidden',
      }}>
        <div style={{
          padding: '8px 12px', background: COLORS.brand + '15', fontWeight: TYPO.weights.bold,
          color: COLORS.brandText || COLORS.brand, fontSize: TYPO.sizes.sm,
          textTransform: 'uppercase', letterSpacing: '0.06em',
        }}>Vlastné príplatky — len v tejto ponuke</div>
        <div style={{ padding: SPACE.sm, display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
            Bod sa v PDF zobrazí v bloku <strong>Príplatky k cene diela</strong> ako bullet. Do spoločného
            katalógu VOP sa nezapíše — ostatné ponuky ostávajú bez neho.
          </div>
          {vlastneBody.length === 0 && (
            <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, fontStyle: 'italic' }}>
              Žiadny vlastný bod.
            </div>
          )}
          {vlastneBody.map((b, i) => (
            <div key={b.id} style={{
              display: 'flex', gap: SPACE.sm, alignItems: 'flex-start',
              padding: SPACE.xs, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm,
            }}>
              <span style={{ fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, color: COLORS.muted,
                fontWeight: TYPO.weights.bold, minWidth: 18, paddingTop: 6 }}>•</span>
              <textarea value={b.text || ''} rows={2}
                onChange={e => zmenVlastnyBod(b.id, { text: e.target.value })}
                placeholder="Text bodu tak, ako má byť v PDF"
                style={{ flex: 1, minWidth: 0, fontSize: TYPO.sizes.sm, padding: '5px 8px',
                  border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontFamily: 'inherit',
                  resize: 'vertical', boxSizing: 'border-box' }} />
              <StranaPrepinac hodnota={b.strana || ''} onChange={s => zmenVlastnyBod(b.id, { strana: s })} />
              <button type="button" onClick={() => zmazVlastnyBod(b.id)} title="Zmazať tento bod"
                style={{ flexShrink: 0, padding: '2px 8px', fontSize: 10.5, fontWeight: 700,
                  borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit',
                  border: `1px solid ${COLORS.remove || '#dc2626'}`, background: '#fff',
                  color: COLORS.remove || '#dc2626' }}>Zmazať</button>
            </div>
          ))}
          <div>
            <button type="button" onClick={pridajVlastnyBod}
              style={{ padding: '6px 12px', fontSize: TYPO.sizes.xs, fontWeight: 700,
                borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit', border: 'none',
                background: COLORS.add, color: '#fff' }}>+ Pridať bod</button>
          </div>
        </div>
      </div>
    </div>
  )
}

// Výber stĺpca pre bod v PDF — platí LEN pre otvorenú cenovú ponuku.
// A = automaticky (bod padne do kratšieho stĺpca, ako to bolo doteraz), V = vľavo, P = vpravo.
function StranaPrepinac({ hodnota, onChange }) {
  const volby = [
    { kluc: '',       znak: 'A', popis: 'Automaticky — bod si nájde kratší stĺpec' },
    { kluc: 'vlavo',  znak: 'V', popis: 'Vždy v ľavom stĺpci PDF' },
    { kluc: 'vpravo', znak: 'P', popis: 'Vždy v pravom stĺpci PDF' },
  ]
  return (
    <div style={{ display: 'flex', gap: 2, flexShrink: 0 }}>
      {volby.map(v => {
        const zvolene = (hodnota || '') === v.kluc
        return (
          <button key={v.kluc || 'auto'} type="button" title={v.popis}
            onClick={() => onChange(v.kluc)}
            style={{
              width: 22, height: 22, padding: 0, fontSize: 10.5, fontWeight: 700,
              borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit',
              border: `1px solid ${zvolene ? COLORS.brand : COLORS.line}`,
              background: zvolene ? COLORS.brand : '#fff',
              color: zvolene ? '#fff' : COLORS.muted,
            }}>{v.znak}</button>
        )
      })}
    </div>
  )
}



// ══════════════════════════════════════════════════════════════════
// RECORD MODAL — edit / new cez useRecordEditor (S1)
// Lock + dirty + Form→Confirm + DIFF — všetko zabudované v hooku.
// ══════════════════════════════════════════════════════════════════


// CP_OTVOR_V1 (Mirko 22. 10. 2026: „prečo si to neprerobil vsade, pole na adresu je jeden riadok?!!!“): vlastná kópia
// okna NoviCustomerDialog (adresa v jednom riadku) zmazaná — CP používa spoločné components/NoviCustomerDialog.jsx
// s adresou v bunkách (AdresaBunky, ústava 23.Z.1), rovnako ako Objednávky, Obhliadky, Poterový protokol a Predajňa (0.J).

function RecordModal({ open, record, user, onClose, onSaved }) {
  const isNew = !record

  const ed = useRecordEditor({
    resource: CFG.resource,
    id: record?.id || null,
    user,
    initial: {
      quote_number: record?.quote_number || '',
      stavba:       record?.stavba       || '',
      status:       record?.status       || 'draft',
      notes:        record?.notes        || '',
    },
    fields: EDIT_FIELDS,
    onSubmit: async (values) => {
      const r = await fetchAuth(
        isNew ? CFG.apiBase : `${CFG.apiBase}/${record.id}`,
        { method: isNew ? 'POST' : 'PUT', body: JSON.stringify(values) }
      )
      if (!r.ok) {
        const d = await r.json().catch(() => ({}))
        // dedup (ústava sek. 13) — backend vracia 409 pri duplicite
        if (r.status === 409) throw new Error(d.message || 'Taký záznam už existuje.')
        throw new Error(d.error || 'Uloženie zlyhalo.')
      }
    },
  })

  if (!open) return null

  const doClose = () => ed.requestClose(onClose)

  const validate = (v) => null

  const handleConfirm = async () => {
    const ok = await ed.submit()
    if (ok) onSaved()
  }

  const readOnly = !ed.canEdit

  return (
    <>
      <Modal
        open
        onClose={doClose}
        onDirtyClose={doClose}
        isDirty={ed.isDirty}
        title={isNew ? CFG.newLabel : `Upraviť — ${record.quote_number || record.stavba || record.id}`}
        subtitle={ed.phase === 'confirm' ? 'Skontroluj zmeny pred uložením' : ''}
        maxWidth={640}
        footer={
          ed.phase === 'form' ? (
            <>
              <BtnGhost onClick={doClose}>Zrušiť</BtnGhost>
              <BtnAdd onClick={() => ed.goConfirm(validate)} disabled={readOnly}>
                Uložiť →
              </BtnAdd>
            </>
          ) : (
            <>
              <BtnGhost onClick={ed.back}>← Späť na úpravu</BtnGhost>
              <BtnAdd onClick={handleConfirm} disabled={ed.submitting}>
                {ed.submitting ? 'Ukladám…' : '✓ Potvrdiť uloženie'}
              </BtnAdd>
            </>
          )
        }
      >
        {/* LOCK banner — záznam upravuje niekto iný (ústava 53.7) */}
        {readOnly && ed.lockedBy && (
          <div style={{
            background: TINT.remove,
            border: `1px solid ${COLORS.remove}`,
            borderRadius: RADIUS.md,
            padding: SPACE.sm,
            marginBottom: SPACE.md,
            fontSize: TYPO.sizes.sm,
            color: COLORS.remove,
          }}>
            Záznam práve upravuje <strong>{ed.lockedBy}</strong>. Editácia je zamknutá.
          </div>
        )}

        {ed.error && (
          <div style={{
            background: TINT.remove,
            border: `1px solid ${COLORS.remove}`,
            borderRadius: RADIUS.md,
            padding: SPACE.sm,
            marginBottom: SPACE.md,
            fontSize: TYPO.sizes.sm,
            color: COLORS.remove,
          }}>{ed.error}</div>
        )}

        {ed.phase === 'form' ? (
          // ── FORM fáza ──────────────────────────────────────────────
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            <Field label="Číslo CP">
              <input type="text" value={ed.values.quote_number} disabled={readOnly}
                onChange={e => ed.set('quote_number', e.target.value)} style={inputStyle} />
            </Field>
            <Field label="Stavba">
              <input type="text" value={ed.values.stavba} disabled={readOnly}
                onChange={e => ed.set('stavba', e.target.value)} style={inputStyle} />
            </Field>
            <Field label="Stav">
              <SearchableSelect value={ed.values.status} onChange={v => ed.set('status', v)}
                options={[
                  { value: 'draft',    label: 'Pracovná' },
                  { value: 'sent',     label: 'Odoslaná' },
                  { value: 'accepted', label: 'Akceptovaná' },
                  { value: 'rejected', label: 'Zamietnutá' },
                ]} />
            </Field>
            <Field label="Poznámka">
              <textarea value={ed.values.notes} disabled={readOnly}
                onChange={e => ed.set('notes', e.target.value)} rows={3}
                style={{ ...inputStyle, resize: 'vertical' }} />
            </Field>
          </div>
        ) : (
          // ── CONFIRM fáza — DIFF prehľad (ústava 53.8) ───────────────
          <div>
            {isNew ? (
              <p style={{ fontSize: TYPO.sizes.base, color: COLORS.text }}>
                Vytvorí sa nový záznam <strong>{ed.values.name}</strong>.
              </p>
            ) : ed.diff.length === 0 ? (
              <p style={{ color: COLORS.muted }}>Žiadne zmeny.</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                <thead>
                  <tr style={{ background: TINT.nav }}>
                    <th style={thStyle}>Pole</th>
                    <th style={thStyle}>Pôvodné</th>
                    <th style={thStyle}>Nové</th>
                  </tr>
                </thead>
                <tbody>
                  {ed.diff.map(d => (
                    <tr key={d.name}>
                      <td style={tdStyle}>{d.label}</td>
                      <td style={{ ...tdStyle, color: COLORS.muted, textDecoration: 'line-through' }}>
                        {d.from}
                      </td>
                      <td style={{ ...tdStyle, color: COLORS.add, fontWeight: TYPO.weights.semibold }}>
                        {d.to}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </Modal>

      {/* DIRTY dialóg — Uložiť / Pokračovať / Zahodiť (ústava 53.1) */}
      <Modal.DirtyConfirm {...ed.dirtyProps} />
    </>
  )
}



const inputStyle = {
  width: '100%',
  padding: '6px 10px',
  fontSize: TYPO.sizes.base,
  fontFamily: 'inherit',
  border: `1px solid ${COLORS.line}`,
  borderRadius: RADIUS.md,
  outline: 'none',
  boxSizing: 'border-box',
}
const thStyle = {
  textAlign: 'left', padding: '6px 10px',
  fontSize: TYPO.sizes.xs, color: COLORS.nav,
  textTransform: 'uppercase', letterSpacing: '0.04em',
  borderBottom: `1px solid ${COLORS.line}`,
}
const tdStyle = {
  padding: '6px 10px',
  borderBottom: `1px solid ${COLORS.lineSoft}`,
}

// ╔══════════════════════════════════════════════════════════════════╗
// ║  DoD CHECKLIST — skopíruj do HANDOFF, odškrtni pred dokončením    ║
// ║  (ústava 9.D.1 bod 3). Modul NIE JE hotový kým nie sú všetky ✅.  ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  [ ] CFG vyplnené (resource, apiBase, labels)                    ║
// ║  [ ] EDIT_FIELDS = všetky editovateľné polia (kvôli DIFF)        ║
// ║  [ ] LOCK funguje — test 2 okná naraz (53.7)                     ║
// ║  [ ] DIRTY dialóg pri zatvorení s neuloženými zmenami (53.1)     ║
// ║  [ ] Form → Confirm + DIFF pred uložením (12.0/3, 53.8)         ║
// ║  [ ] HistoryPanel ukazuje audit záznamu (12.0/1)                 ║
// ║  [ ] hľadanie v zozname funguje (56)                             ║
// ║  [ ] žiadny plain <select> — len SearchableSelect (56.11)        ║
// ║  [ ] žiadne inline farby pozadia — len TINT/tint() (21.15)       ║
// ║  [ ] dedup — backend vracia 409 pri duplicite (13)               ║
// ║  [ ] mod+N a / skratky + cheatsheet (54)                         ║
// ║  [ ] starý modul porovnaný — všetky polia/funkcie prenesené      ║
// ║  [ ] ÚSTAVA-REVIEW — druhý prechod kódu bod po bode (9.D.3)      ║
// ╚══════════════════════════════════════════════════════════════════╝


// PDF preview cez blob URL — fetchAuth posiela Bearer token, iframe by nemohol
function PdfPreviewModal({ quote, onClose }) {
  const [blobUrl, setBlobUrl] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    let cancelled = false
    let url = null
    setLoading(true); setError(null)
    fetchAuth(`/api/quotes/${quote.id}/pdf?ts=${Date.now()}`, { cache: 'no-store' })
      .then(r => {
        if (!r.ok) throw new Error('HTTP ' + r.status)
        return r.blob()
      })
      .then(blob => {
        if (cancelled) return
        url = URL.createObjectURL(blob)
        setBlobUrl(url)
        setLoading(false)
      })
      .catch(e => { if (!cancelled) { setError(e.message); setLoading(false) } })
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url) }
  }, [quote.id, refreshKey])

  return (
    <Modal open title={`Náhľad PDF — ${quote.id}`} onClose={onClose} width={1100}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm, height: '78vh' }}>
        <div style={{ display: 'flex', gap: SPACE.sm, alignItems: 'center', fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
          <span>Náhľad PDF. Pre stiahnutie použi PDF v hlavičke.</span>
          <div style={{ flex: 1 }} />
          <button onClick={() => setRefreshKey(k => k + 1)} disabled={loading}
            style={{ padding: '4px 10px', background: 'transparent', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, cursor: loading ? 'wait' : 'pointer', fontSize: TYPO.sizes.xs }}>
            Obnoviť
          </button>
        </div>
        {loading && (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: COLORS.muted }}>
            Generujem PDF…
          </div>
        )}
        {error && (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: COLORS.remove, padding: SPACE.lg }}>
            Chyba pri generovaní PDF: {error}
          </div>
        )}
        {!loading && !error && blobUrl && (
          <iframe
            src={blobUrl + '#zoom=page-fit'}
            title="PDF Preview"
            style={{ flex: 1, width: '100%', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, background: '#f5f5f5' }}
          />
        )}
      </div>
    </Modal>
  )
}

// ── (f) CP → NOVÁ zákazka (Mirko 20.7., office hlásil že sa nedá): dáta z CP, väzba quotes.projectId ──
function CpZakazkaModal({ row, onClose, onDone, toast, customers = [] }) {
  const [busy, setBusy] = useState(false)
  const [f, setF] = useState({ name: row.stavba || '', segment: 'firma', fakturacia: '' })
  // 🔴 Mirko 3.8.: „nefunguje uloženie mena a nevytvorí zákazku" — CP vzniknutá z obhliadky často
  // NEMÁ partnera z číselníka (obhliadka ho má len ako voľný text). Preto sa dá vybrať/založiť TU
  // a zapíše sa späť aj do CP (ústava: zákazník = partner, nie voľný text).
  const [custList, setCustList] = useState(customers)
  const [custId, setCustId] = useState(row.customerId || '')
  const [novyOpen, setNovyOpen] = useState(false)
  useEffect(() => { if (!customers.length) fetchAuth('/api/customers').then(r => r.ok ? r.json() : []).then(d => setCustList(Array.isArray(d) ? d : [])).catch(() => {}) }, [])
  useEffect(() => { const h = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose && onClose() } }; window.addEventListener('keydown', h); return () => window.removeEventListener('keydown', h) }, [onClose])
  const fld = { width: '100%', padding: '8px 10px', border: '1px solid #d6dde6', borderRadius: 8, fontFamily: 'inherit', fontSize: 13, boxSizing: 'border-box', outline: 'none', marginTop: 4 }
  const lab2 = { fontSize: 12, fontWeight: 700, color: '#475569' }
  const submit = async () => {
    if (busy) return
    if (!custId) { alert('Vyber zákazníka z číselníka (alebo ho založ tlačidlom „+ Nový").'); return }
    if (!f.name.trim()) { alert('Názov zákazky je povinný.'); return }
    if (!f.fakturacia) { alert('Fakturácia je povinná (jednorázová / opakujúca) — ústava.'); return }
    setBusy(true)
    try {
      // GPS + adresa z obhliadky prepojenej s touto CP (chrbtica, Mirko 3.8.) — predtym sa ako adresa ukladal NAZOV zakazky
      let obAdresa = '', obLat = '', obLng = ''
      try {
        const obs = await fetchAuth('/api/obhliadky').then(r => r.ok ? r.json() : [])
        const ob = (Array.isArray(obs) ? obs : []).find(o => o.quote_id === row.id)
        if (ob) { obAdresa = ob.adresa || ''; obLat = ob.gps_lat || ''; obLng = ob.gps_lng || '' }
      } catch (_) {}
      const pr = await fetchAuth('/api/projects', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
        name: f.name.trim(), customerId: custId, status: 'planned', segment: f.segment, fakturacia: f.fakturacia,
        // 🔴 ADRESA STAVBY NIE JE NÁZOV (Mirko 3.8.: „adresu zadávam iba načítaním GPS").
        // Ak obhliadka adresu nemá, necháme PRÁZDNU — radšej prázdna než názov zákazky v adrese.
        site_address: obAdresa || '', gps_lat: obLat, gps_lng: obLng,
        notes: 'Z cenovej ponuky ' + row.id,
      }) })
      const pj = await pr.json(); if (!pr.ok) throw new Error(pj.message || pj.error || 'zákazka sa nevytvorila')
      // väzba CP→zákazka (nervová sústava): quotes.projectId
      // 11.9.2026 (bod 54): posiela sa LEN väzba (projectId + customerId), nie celý riadok — pri odoslanej CP DOC_LOCK
      // porovnával všetky polia a vracal 423, ktoré try/catch zhltol a toast hlásil úspech (CP ostala bez zákazky).
      // Backend od 11.9. priradenie zákazky k odoslanej CP povoľuje; ak by aj tak zlyhalo, používateľ to MUSÍ vidieť.
      try {
        const lr = await fetchAuth('/api/quotes/' + row.id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ projectId: pj.id, customerId: custId }) })
        if (!lr.ok) { const lj = await lr.json().catch(() => ({})); toast.error('Zákazka ' + pj.id + ' vznikla, ale CP ' + row.id + ' sa s ňou NEPREPOJILA: ' + (lj.error || lj.message || ('HTTP ' + lr.status))); onDone(); return }
      } catch (e2) { toast.error('Zákazka ' + pj.id + ' vznikla, ale prepojenie s CP zlyhalo: ' + e2.message); onDone(); return }
      toast.success('Zákazka ' + pj.id + ' vytvorená a prepojená s CP ' + row.id + '.')
      onDone()
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message); setBusy(false) }
  }
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: 20, width: 'min(500px,94vw)' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
          <div style={{ fontWeight: 800, fontSize: 16 }}>Vytvoriť zákazku z CP {row.id}</div>
          <button onClick={onClose} style={{ marginLeft: 'auto', padding: '6px 10px', border: 'none', background: '#f1f5f9', borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit' }}>✕</button>
        </div>
        <div style={{ fontSize: 12.5, color: '#475569', marginBottom: 12 }}>Zákazník a názov sa preberú z CP — názov aj ostatné môžeš upraviť (aj neskôr v Zákazkách). Väzba CP ↔ zákazka sa zapamätá.</div>
        <div style={{ display: 'grid', gap: 10 }}>
          <label style={lab2}>Zákazník *
            <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <SearchableSelect value={custId} onChange={setCustId} menuPortal
                  options={custList.map(c => ({ value: c.id, label: `${c.name} (${c.id})` }))}
                  placeholder="Hľadať podľa mena alebo IČO…" />
              </div>
              <button type="button" onClick={() => setNovyOpen(true)}
                style={{ padding: '0 12px', border: '1px solid #41694C', background: '#fff', color: '#41694C', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 12.5, fontFamily: 'inherit', whiteSpace: 'nowrap' }}>+ Nový</button>
            </div>
            {!custId && <div style={{ fontSize: 11.5, color: '#B42318', marginTop: 3 }}>Táto CP nemá zákazníka z číselníka — vyber ho alebo založ, uloží sa aj do CP.</div>}
          </label>
          <label style={lab2}>Názov zákazky *<input value={f.name} onChange={e => setF(s => ({ ...s, name: e.target.value }))} style={fld} /></label>
          <div style={{ display: 'flex', gap: 10 }}>
            <label style={{ ...lab2, flex: 1 }}>Segment *
              <select value={f.segment} onChange={e => setF(s => ({ ...s, segment: e.target.value }))} style={fld}>
                <option value="firma">FIRMA</option><option value="rd">RD — rodinný dom</option>
              </select>
            </label>
            <label style={{ ...lab2, flex: 1 }}>Fakturácia *
              <select value={f.fakturacia} onChange={e => setF(s => ({ ...s, fakturacia: e.target.value }))} style={{ ...fld, borderColor: f.fakturacia ? '#d6dde6' : '#dc2626' }}>
                <option value="">— vyber —</option>
                <option value="jednorazova">Jednorázová</option>
                <option value="opakujuca">Opakujúca — priebežná</option>
              </select>
            </label>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 14 }}>
          <button onClick={onClose} style={{ padding: '9px 14px', border: '1px solid #d6dde6', background: '#fff', borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 600 }}>Zrušiť</button>
          <button disabled={busy} onClick={submit} style={{ padding: '9px 16px', border: 'none', background: '#16a34a', color: '#fff', borderRadius: 8, cursor: busy ? 'wait' : 'pointer', fontFamily: 'inherit', fontWeight: 700 }}>{busy ? 'Vytváram…' : 'Vytvoriť zákazku'}</button>
        </div>
      </div>
      <NoviCustomerDialog open={novyOpen} prefillName={row.customer_name || row.kontakt_meno || f.name || ''}
        onClose={() => setNovyOpen(false)}
        onCreated={c => { setCustList(prev => [...prev, c]); setCustId(c.id); setNovyOpen(false) }} />
    </div>
  )
}

// V3 131.10 — kontaktné osoby partnera v CP. Osoby sa ponúkajú priamo pri e-mailoch (KontaktyPonuka: výber doplní e-mail aj telefón,
// „+ Nový kontakt partnera“ založí kontakt ručne). Tu: rozpísaný e-mail alebo telefón, ktorý partner ešte nemá, sa uloží k partnerovi.
function KontaktyPartneraCP({ customerId, quote }) {
  const toast = useToast()
  const { rows, pridaj } = usePartnerKontakty(customerId)
  const [o, setO] = useState({ titul: '', first_name: '', last_name: '' })   // KONTAKT_BUNKY_V1 (ústava 139)
  const [ukladam, setUkladam] = useState(false)
  if (!customerId) return null
  const em = String(quote.contact_email || '').trim().toLowerCase()
  const ph = String(quote.contact_phone || '').replace(/\D/g, '').slice(-9)
  const znamy = rows.some(c => (em && String(c.email || '').trim().toLowerCase() === em) || (ph.length === 9 && String(c.telefon || '').replace(/\D/g, '').slice(-9) === ph))
  if (!(em || ph) || znamy) return null
  const uloz = async () => {
    if (!o.first_name.trim() || !o.last_name.trim()) { toast.error('Zadaj meno aj priezvisko kontaktu'); return }
    setUkladam(true)
    try {
      const r = await fetchAuth('/api/partner-contacts', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customer_id: customerId, titul: o.titul.trim(), first_name: o.first_name.trim(), last_name: o.last_name.trim(), email: quote.contact_email || '', telefon: quote.contact_phone || '', funkcia: 'rozpočtár' }) })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(d.error || 'Uloženie zlyhalo')
      toast.success(d.duplicate ? 'Tento kontakt už pri partnerovi je' : 'Kontakt uložený k partnerovi: ' + menoZBuniek(o))
      setO({ titul: '', first_name: '', last_name: '' })
      pridaj(d)
    } catch (e) { toast.error(e.message) } finally { setUkladam(false) }
  }
  const mini = { padding: '3px 6px', fontSize: TYPO.sizes.xs, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontFamily: 'inherit', background: COLORS.bg }
  return (
    <div style={{ marginTop: 6, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', fontSize: TYPO.sizes.xs }}>
      <span style={{ color: COLORS.muted }}>Kontakt na CP ({String(quote.contact_email || quote.contact_phone || '').trim()}) partner ešte nemá:</span>
      {[['titul', 'Titul', 56], ['first_name', 'Meno', 110], ['last_name', 'Priezvisko', 130]].map(([k, ph, w]) => (
        <input key={k} value={o[k]} onChange={e => { const x = e.target.value; setO(s => ({ ...s, [k]: x })) }} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); uloz() } }} placeholder={ph} style={{ ...mini, width: w }} />
      ))}
      <button type="button" disabled={ukladam} onClick={uloz} style={{ ...mini, border: `1px solid ${COLORS.add}`, color: COLORS.add, cursor: 'pointer', fontWeight: TYPO.weights.bold }}>Uložiť kontakt k partnerovi</button>
    </div>
  )
}

// ── cp_katalog_v1 (Mirko 20. 10. 2026): výber katalógov referencií v okne Poslať CP ──
// Nič nie je predvolene zaškrtnuté — rozhoduje človek pri každom odoslaní. Nenahratý katalóg sa nedá zaškrtnúť.
const KATALOG_NAZOV = { omietky: 'Omietky', potery: 'Potery' }
function KatalogyVolba({ dostupne, vybrane, onZmena }) {
  const prepni = (k) => onZmena(vybrane.includes(k) ? vybrane.filter(x => x !== k) : [...vybrane, k])
  return (
    <div style={{ padding: '8px 10px', background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm }}>
      <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, marginBottom: 4 }}>Priložiť katalóg referencií</div>
      {Object.keys(KATALOG_NAZOV).map(k => {
        const inf = dostupne && dostupne[k]
        return (
          <label key={k} style={{ fontSize: TYPO.sizes.sm, display: 'flex', alignItems: 'center', gap: 8, cursor: inf ? 'pointer' : 'default', color: inf ? COLORS.text : COLORS.muted }}>
            <input type="checkbox" disabled={!inf} checked={!!inf && vybrane.includes(k)} onChange={() => prepni(k)} />
            <span>{KATALOG_NAZOV[k]}{inf ? (inf.velkost ? ' · ' + (inf.velkost / 1048576).toFixed(1).replace('.', ',') + ' MB' : '') : ' — nie je nahratý (nahrá ho office v Nastavenia → Logá)' /* cp_katalog_v2 */}</span>
          </label>
        )
      })}
    </div>
  )
}
